// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true"
// @generated from file creativefabrica/preset/v1/types.proto (package creativefabrica.preset.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Surface, SurfaceJson } from "@repo/rpc-types-creativefabrica-common-v1/surface/v1";
import { file_creativefabrica_common_v1_surface_v1_types } from "@repo/rpc-types-creativefabrica-common-v1/surface/v1";
import type { StructJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file creativefabrica/preset/v1/types.proto.
 */
export const file_creativefabrica_preset_v1_types: GenFile = /*@__PURE__*/
  fileDesc("CiVjcmVhdGl2ZWZhYnJpY2EvcHJlc2V0L3YxL3R5cGVzLnByb3RvEhljcmVhdGl2ZWZhYnJpY2EucHJlc2V0LnYxIoMECgpGaWVsZFZhbHVlEhYKDHN0cmluZ192YWx1ZRgBIAEoCUgAEhcKDWludGVnZXJfdmFsdWUYAiABKANIABIVCgtmbG9hdF92YWx1ZRgDIAEoAUgAEhcKDWJvb2xlYW5fdmFsdWUYBCABKAhIABJJCgxvYmplY3RfdmFsdWUYBSABKAsyMS5jcmVhdGl2ZWZhYnJpY2EucHJlc2V0LnYxLkZpZWxkVmFsdWUuT2JqZWN0VmFsdWVIABJHCgthcnJheV92YWx1ZRgGIAEoCzIwLmNyZWF0aXZlZmFicmljYS5wcmVzZXQudjEuRmllbGRWYWx1ZS5BcnJheVZhbHVlSAAasgEKC09iamVjdFZhbHVlEk0KBmZpZWxkcxgBIAMoCzI9LmNyZWF0aXZlZmFicmljYS5wcmVzZXQudjEuRmllbGRWYWx1ZS5PYmplY3RWYWx1ZS5GaWVsZHNFbnRyeRpUCgtGaWVsZHNFbnRyeRILCgNrZXkYASABKAkSNAoFdmFsdWUYAiABKAsyJS5jcmVhdGl2ZWZhYnJpY2EucHJlc2V0LnYxLkZpZWxkVmFsdWU6AjgBGkIKCkFycmF5VmFsdWUSNAoFaXRlbXMYASADKAsyJS5jcmVhdGl2ZWZhYnJpY2EucHJlc2V0LnYxLkZpZWxkVmFsdWVCBwoFdmFsdWUipgUKD0ZpZWxkRGVzY3JpcHRvchIQCghyZXF1aXJlZBgBIAEoCBIMCgR1bml0GAIgASgJEkEKC3N0cmluZ190eXBlGAMgASgLMiouY3JlYXRpdmVmYWJyaWNhLnByZXNldC52MS5TdHJpbmdGaWVsZFR5cGVIABJDCgxpbnRlZ2VyX3R5cGUYBCABKAsyKy5jcmVhdGl2ZWZhYnJpY2EucHJlc2V0LnYxLkludGVnZXJGaWVsZFR5cGVIABI/CgpmbG9hdF90eXBlGAUgASgLMikuY3JlYXRpdmVmYWJyaWNhLnByZXNldC52MS5GbG9hdEZpZWxkVHlwZUgAEkMKDGJvb2xlYW5fdHlwZRgGIAEoCzIrLmNyZWF0aXZlZmFicmljYS5wcmVzZXQudjEuQm9vbGVhbkZpZWxkVHlwZUgAEkEKC29iamVjdF90eXBlGAcgASgLMiouY3JlYXRpdmVmYWJyaWNhLnByZXNldC52MS5PYmplY3RGaWVsZFR5cGVIABI/CgphcnJheV90eXBlGAggASgLMikuY3JlYXRpdmVmYWJyaWNhLnByZXNldC52MS5BcnJheUZpZWxkVHlwZUgAEhIKCmRlcHJlY2F0ZWQYCSABKAgSGAoLcmVwbGFjZWRfYnkYCiABKAlIAYgBARJgChRkZXByZWNhdGVkX3ZhbHVlX21hcBgLIAMoCzJCLmNyZWF0aXZlZmFicmljYS5wcmVzZXQudjEuRmllbGREZXNjcmlwdG9yLkRlcHJlY2F0ZWRWYWx1ZU1hcEVudHJ5GjkKF0RlcHJlY2F0ZWRWYWx1ZU1hcEVudHJ5EgsKA2tleRgBIAEoCRINCgV2YWx1ZRgCIAEoCToCOAFCBgoEdHlwZUIOCgxfcmVwbGFjZWRfYnkiugIKD1N0cmluZ0ZpZWxkVHlwZRIWCg5hbGxvd2VkX3ZhbHVlcxgBIAMoCRIaCg1kZWZhdWx0X3ZhbHVlGAIgASgJSACIAQESFwoKbWluX2xlbmd0aBgDIAEoBUgBiAEBEhcKCm1heF9sZW5ndGgYBCABKAVIAogBARJZChB2YWx1ZV9leHBhbnNpb25zGAUgAygLMj8uY3JlYXRpdmVmYWJyaWNhLnByZXNldC52MS5TdHJpbmdGaWVsZFR5cGUuVmFsdWVFeHBhbnNpb25zRW50cnkaNgoUVmFsdWVFeHBhbnNpb25zRW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJOgI4AUIQCg5fZGVmYXVsdF92YWx1ZUINCgtfbWluX2xlbmd0aEINCgtfbWF4X2xlbmd0aCKMAQoQSW50ZWdlckZpZWxkVHlwZRIWCg5hbGxvd2VkX3ZhbHVlcxgBIAMoAxIaCg1kZWZhdWx0X3ZhbHVlGAIgASgDSACIAQESEAoDbWluGAMgASgDSAGIAQESEAoDbWF4GAQgASgDSAKIAQFCEAoOX2RlZmF1bHRfdmFsdWVCBgoEX21pbkIGCgRfbWF4InIKDkZsb2F0RmllbGRUeXBlEhoKDWRlZmF1bHRfdmFsdWUYASABKAFIAIgBARIQCgNtaW4YAiABKAFIAYgBARIQCgNtYXgYAyABKAFIAogBAUIQCg5fZGVmYXVsdF92YWx1ZUIGCgRfbWluQgYKBF9tYXgiQAoQQm9vbGVhbkZpZWxkVHlwZRIaCg1kZWZhdWx0X3ZhbHVlGAEgASgISACIAQFCEAoOX2RlZmF1bHRfdmFsdWUiwAEKD09iamVjdEZpZWxkVHlwZRJOCgpwcm9wZXJ0aWVzGAEgAygLMjouY3JlYXRpdmVmYWJyaWNhLnByZXNldC52MS5PYmplY3RGaWVsZFR5cGUuUHJvcGVydGllc0VudHJ5Gl0KD1Byb3BlcnRpZXNFbnRyeRILCgNrZXkYASABKAkSOQoFdmFsdWUYAiABKAsyKi5jcmVhdGl2ZWZhYnJpY2EucHJlc2V0LnYxLkZpZWxkRGVzY3JpcHRvcjoCOAEiSwoOQXJyYXlGaWVsZFR5cGUSOQoFaXRlbXMYASABKAsyKi5jcmVhdGl2ZWZhYnJpY2EucHJlc2V0LnYxLkZpZWxkRGVzY3JpcHRvciKLAQoKQ29pbkNvbmZpZxIRCgljb2luX3R5cGUYASABKAkSQAoMcHJpY2luZ190eXBlGAIgASgOMiouY3JlYXRpdmVmYWJyaWNhLnByZXNldC52MS5Db2luUHJpY2luZ1R5cGUSGAoLY29pbl9hbW91bnQYAyABKAVIAIgBAUIOCgxfY29pbl9hbW91bnQijQIKDVByZXNldFN1bW1hcnkSEQoJcHJlc2V0X2lkGAEgASgJEgwKBG5hbWUYAiABKAkSNQoIbW9kYWxpdHkYAyABKA4yIy5jcmVhdGl2ZWZhYnJpY2EucHJlc2V0LnYxLk1vZGFsaXR5EjoKC291dHB1dF90eXBlGAQgASgOMiUuY3JlYXRpdmVmYWJyaWNhLnByZXNldC52MS5PdXRwdXRUeXBlEhMKC2Rlc2NyaXB0aW9uGAUgASgJEgwKBHRhZ3MYBiADKAkSPwoIc3VyZmFjZXMYCCADKA4yLS5jcmVhdGl2ZWZhYnJpY2EuY29tbW9uLnYxLnN1cmZhY2UudjEuU3VyZmFjZUoECAcQCCKCAQoPUHJlc2V0TW9kZWxJbmZvEg0KBW1vZGVsGAEgASgJEhAKCHByb3ZpZGVyGAIgASgJEhIKCmlzX2RlZmF1bHQYAyABKAgSOgoLY29pbl9jb25maWcYBCABKAsyJS5jcmVhdGl2ZWZhYnJpY2EucHJlc2V0LnYxLkNvaW5Db25maWcigAIKDFN5c3RlbVByb21wdBI5CgR0eXBlGAEgASgOMisuY3JlYXRpdmVmYWJyaWNhLnByZXNldC52MS5TeXN0ZW1Qcm9tcHRUeXBlEgwKBHRleHQYAiABKAkSSQoJdmFyaWFibGVzGAMgAygLMjYuY3JlYXRpdmVmYWJyaWNhLnByZXNldC52MS5TeXN0ZW1Qcm9tcHQuVmFyaWFibGVzRW50cnkaXAoOVmFyaWFibGVzRW50cnkSCwoDa2V5GAEgASgJEjkKBXZhbHVlGAIgASgLMiouY3JlYXRpdmVmYWJyaWNhLnByZXNldC52MS5GaWVsZERlc2NyaXB0b3I6AjgBIr8HCgtNb2RlbENvbmZpZxJTCg9wcm92aWRlcl9wYXJhbXMYASADKAsyOi5jcmVhdGl2ZWZhYnJpY2EucHJlc2V0LnYxLk1vZGVsQ29uZmlnLlByb3ZpZGVyUGFyYW1zRW50cnkSTwoNaW5wdXRfb3B0aW9ucxgCIAMoCzI4LmNyZWF0aXZlZmFicmljYS5wcmVzZXQudjEuTW9kZWxDb25maWcuSW5wdXRPcHRpb25zRW50cnkSVwoRaW5wdXRfY29uc3RyYWludHMYAyADKAsyPC5jcmVhdGl2ZWZhYnJpY2EucHJlc2V0LnYxLk1vZGVsQ29uZmlnLklucHV0Q29uc3RyYWludHNFbnRyeRJBCg1vdXRwdXRfc2NoZW1hGAQgASgLMiouY3JlYXRpdmVmYWJyaWNhLnByZXNldC52MS5GaWVsZERlc2NyaXB0b3ISYAoWaW5wdXRfcm9sZV9jb25zdHJhaW50cxgFIAMoCzJALmNyZWF0aXZlZmFicmljYS5wcmVzZXQudjEuTW9kZWxDb25maWcuSW5wdXRSb2xlQ29uc3RyYWludHNFbnRyeRJJChZpbnB1dF9jb25zdHJhaW50X3J1bGVzGAYgAygLMikuY3JlYXRpdmVmYWJyaWNhLnByZXNldC52MS5Db25zdHJhaW50UnVsZRI1ChRyZXNwb25zZV9qc29uX3NjaGVtYRgHIAEoCzIXLmdvb2dsZS5wcm90b2J1Zi5TdHJ1Y3QaXAoTUHJvdmlkZXJQYXJhbXNFbnRyeRILCgNrZXkYASABKAkSNAoFdmFsdWUYAiABKAsyJS5jcmVhdGl2ZWZhYnJpY2EucHJlc2V0LnYxLkZpZWxkVmFsdWU6AjgBGl8KEUlucHV0T3B0aW9uc0VudHJ5EgsKA2tleRgBIAEoCRI5CgV2YWx1ZRgCIAEoCzIqLmNyZWF0aXZlZmFicmljYS5wcmVzZXQudjEuRmllbGREZXNjcmlwdG9yOgI4ARpjChVJbnB1dENvbnN0cmFpbnRzRW50cnkSCwoDa2V5GAEgASgJEjkKBXZhbHVlGAIgASgLMiouY3JlYXRpdmVmYWJyaWNhLnByZXNldC52MS5GaWVsZERlc2NyaXB0b3I6AjgBGmYKGUlucHV0Um9sZUNvbnN0cmFpbnRzRW50cnkSCwoDa2V5GAEgASgJEjgKBXZhbHVlGAIgASgLMikuY3JlYXRpdmVmYWJyaWNhLnByZXNldC52MS5Sb2xlQ29uc3RyYWludDoCOAEi9QQKDlJvbGVDb25zdHJhaW50EgsKA21heBgBIAEoBRILCgNtaW4YCCABKAUSGAoQYWNjZXB0ZWRfZm9ybWF0cxgCIAMoCRIYChBtYXhfZmlsZV9zaXplX21iGAMgASgFEiEKFG1pbl9kdXJhdGlvbl9zZWNvbmRzGAQgASgFSACIAQESIQoUbWF4X2R1cmF0aW9uX3NlY29uZHMYBSABKAVIAYgBARIUCgdtaW5fZnBzGAsgASgFSAKIAQESFAoHbWF4X2ZwcxgMIAEoBUgDiAEBEkcKCmRpbWVuc2lvbnMYBiABKAsyLi5jcmVhdGl2ZWZhYnJpY2EucHJlc2V0LnYxLkRpbWVuc2lvbkNvbnN0cmFpbnRIBIgBARJaChFwcm92aWRlcl9tZXRhZGF0YRgHIAMoCzI/LmNyZWF0aXZlZmFicmljYS5wcmVzZXQudjEuUm9sZUNvbnN0cmFpbnQuUHJvdmlkZXJNZXRhZGF0YUVudHJ5Eh8KF2F1dG9fY29uZm9ybV9kaW1lbnNpb25zGAkgASgIEh8KF2F1dG9fcmVzaXplX29uX292ZXJmbG93GAogASgIGmMKFVByb3ZpZGVyTWV0YWRhdGFFbnRyeRILCgNrZXkYASABKAkSOQoFdmFsdWUYAiABKAsyKi5jcmVhdGl2ZWZhYnJpY2EucHJlc2V0LnYxLkZpZWxkRGVzY3JpcHRvcjoCOAFCFwoVX21pbl9kdXJhdGlvbl9zZWNvbmRzQhcKFV9tYXhfZHVyYXRpb25fc2Vjb25kc0IKCghfbWluX2Zwc0IKCghfbWF4X2Zwc0INCgtfZGltZW5zaW9ucyKaBQoTRGltZW5zaW9uQ29uc3RyYWludBIbChNhbGxvd2VkX3Jlc29sdXRpb25zGAEgAygJEhkKDG1pbl93aWR0aF9weBgCIAEoBUgAiAEBEhkKDG1heF93aWR0aF9weBgDIAEoBUgBiAEBEhoKDW1pbl9oZWlnaHRfcHgYBCABKAVIAogBARIaCg1tYXhfaGVpZ2h0X3B4GAUgASgFSAOIAQESHQoQbWluX2ZyYW1lX3BpeGVscxgGIAEoBUgEiAEBEh0KEG1heF9mcmFtZV9waXhlbHMYByABKAVIBYgBARIdChBtaW5fYXNwZWN0X3JhdGlvGAggASgBSAaIAQESHQoQbWF4X2FzcGVjdF9yYXRpbxgJIAEoAUgHiAEBEh8KEm1pbl9sb25nZXJfc2lkZV9weBgKIAEoBUgIiAEBEh8KEm1heF9sb25nZXJfc2lkZV9weBgLIAEoBUgJiAEBEiAKE21pbl9zaG9ydGVyX3NpZGVfcHgYDCABKAVICogBARIgChNtYXhfc2hvcnRlcl9zaWRlX3B4GA0gASgFSAuIAQFCDwoNX21pbl93aWR0aF9weEIPCg1fbWF4X3dpZHRoX3B4QhAKDl9taW5faGVpZ2h0X3B4QhAKDl9tYXhfaGVpZ2h0X3B4QhMKEV9taW5fZnJhbWVfcGl4ZWxzQhMKEV9tYXhfZnJhbWVfcGl4ZWxzQhMKEV9taW5fYXNwZWN0X3JhdGlvQhMKEV9tYXhfYXNwZWN0X3JhdGlvQhUKE19taW5fbG9uZ2VyX3NpZGVfcHhCFQoTX21heF9sb25nZXJfc2lkZV9weEIWChRfbWluX3Nob3J0ZXJfc2lkZV9weEIWChRfbWF4X3Nob3J0ZXJfc2lkZV9weCL3BQoOQ29uc3RyYWludFJ1bGUSTgoSbXV0dWFsbHlfZXhjbHVzaXZlGAEgASgLMjAuY3JlYXRpdmVmYWJyaWNhLnByZXNldC52MS5NdXR1YWxseUV4Y2x1c2l2ZVJ1bGVIABI7CghyZXF1aXJlcxgCIAEoCzInLmNyZWF0aXZlZmFicmljYS5wcmVzZXQudjEuUmVxdWlyZXNSdWxlSAASPAoJdG90YWxfbWF4GAMgASgLMicuY3JlYXRpdmVmYWJyaWNhLnByZXNldC52MS5Ub3RhbE1heFJ1bGVIABJNChJ0b3RhbF9tYXhfZHVyYXRpb24YBCABKAsyLy5jcmVhdGl2ZWZhYnJpY2EucHJlc2V0LnYxLlRvdGFsTWF4RHVyYXRpb25SdWxlSAASVQoWY29uZGl0aW9uYWxfbWF4X29wdGlvbhgFIAEoCzIzLmNyZWF0aXZlZmFicmljYS5wcmVzZXQudjEuQ29uZGl0aW9uYWxNYXhPcHRpb25SdWxlSAASZwofY29uZGl0aW9uYWxfdW5hdmFpbGFibGVfb3B0aW9ucxgGIAEoCzI8LmNyZWF0aXZlZmFicmljYS5wcmVzZXQudjEuQ29uZGl0aW9uYWxVbmF2YWlsYWJsZU9wdGlvbnNSdWxlSAASQQoMdG90YWxfbWF4X21iGAcgASgLMikuY3JlYXRpdmVmYWJyaWNhLnByZXNldC52MS5Ub3RhbE1heE1iUnVsZUgAEmkKIW1heF9jb21iaW5lZF9kdXJhdGlvbl93aXRoX29wdGlvbhgIIAEoCzI8LmNyZWF0aXZlZmFicmljYS5wcmVzZXQudjEuTWF4Q29tYmluZWREdXJhdGlvbldpdGhPcHRpb25SdWxlSAASVQoWY29uZGl0aW9uYWxfbWluX29wdGlvbhgJIAEoCzIzLmNyZWF0aXZlZmFicmljYS5wcmVzZXQudjEuQ29uZGl0aW9uYWxNaW5PcHRpb25SdWxlSABCBgoEcnVsZSJNChVNdXR1YWxseUV4Y2x1c2l2ZVJ1bGUSNAoGZ3JvdXBzGAEgAygLMiQuY3JlYXRpdmVmYWJyaWNhLnByZXNldC52MS5Sb2xlR3JvdXAiGgoJUm9sZUdyb3VwEg0KBXJvbGVzGAEgAygJIjYKDFJlcXVpcmVzUnVsZRIMCgRyb2xlGAEgASgJEgsKA2FsbBgCIAMoCRILCgNhbnkYAyADKAkiKgoMVG90YWxNYXhSdWxlEg0KBXJvbGVzGAEgAygJEgsKA21heBgCIAEoBSIvCg5Ub3RhbE1heE1iUnVsZRINCgVyb2xlcxgBIAMoCRIOCgZtYXhfbWIYAiABKAUiVwohTWF4Q29tYmluZWREdXJhdGlvbldpdGhPcHRpb25SdWxlEg0KBXJvbGVzGAEgAygJEg4KBm9wdGlvbhgCIAEoCRITCgttYXhfc2Vjb25kcxgDIAEoBSI6ChRUb3RhbE1heER1cmF0aW9uUnVsZRINCgVyb2xlcxgBIAMoCRITCgttYXhfc2Vjb25kcxgCIAEoBSJQChhDb25kaXRpb25hbE1heE9wdGlvblJ1bGUSEQoJd2hlbl9yb2xlGAEgASgJEg4KBm9wdGlvbhgCIAEoCRIRCgltYXhfdmFsdWUYAyABKAEiUAoYQ29uZGl0aW9uYWxNaW5PcHRpb25SdWxlEhEKCXdoZW5fcm9sZRgBIAEoCRIOCgZvcHRpb24YAiABKAkSEQoJbWluX3ZhbHVlGAMgASgBIkcKIUNvbmRpdGlvbmFsVW5hdmFpbGFibGVPcHRpb25zUnVsZRIRCgl3aGVuX3JvbGUYASABKAkSDwoHb3B0aW9ucxgCIAMoCSLTAgoGUHJlc2V0EhEKCXByZXNldF9pZBgBIAEoCRIMCgRuYW1lGAIgASgJEjUKCG1vZGFsaXR5GAMgASgOMiMuY3JlYXRpdmVmYWJyaWNhLnByZXNldC52MS5Nb2RhbGl0eRI6CgtvdXRwdXRfdHlwZRgEIAEoDjIlLmNyZWF0aXZlZmFicmljYS5wcmVzZXQudjEuT3V0cHV0VHlwZRITCgtkZXNjcmlwdGlvbhgFIAEoCRI6Cgh2ZXJzaW9ucxgGIAMoCzIoLmNyZWF0aXZlZmFicmljYS5wcmVzZXQudjEuUHJlc2V0VmVyc2lvbhIPCgdpc19zdHViGAcgASgIEgwKBHRhZ3MYCCADKAkSPwoIc3VyZmFjZXMYCiADKA4yLS5jcmVhdGl2ZWZhYnJpY2EuY29tbW9uLnYxLnN1cmZhY2UudjEuU3VyZmFjZUoECAkQCiLlAQoNUHJlc2V0VmVyc2lvbhIPCgd2ZXJzaW9uGAEgASgFEj4KBnN0YXR1cxgCIAEoDjIuLmNyZWF0aXZlZmFicmljYS5wcmVzZXQudjEuUHJlc2V0VmVyc2lvblN0YXR1cxI+Cg1zeXN0ZW1fcHJvbXB0GAMgASgLMicuY3JlYXRpdmVmYWJyaWNhLnByZXNldC52MS5TeXN0ZW1Qcm9tcHQSQwoNbW9kZWxfY29uZmlncxgEIAMoCzIsLmNyZWF0aXZlZmFicmljYS5wcmVzZXQudjEuUHJlc2V0TW9kZWxDb25maWciwgEKEVByZXNldE1vZGVsQ29uZmlnEg0KBW1vZGVsGAEgASgJEhAKCHByb3ZpZGVyGAIgASgJEhIKCmlzX2RlZmF1bHQYAyABKAgSPAoMbW9kZWxfY29uZmlnGAQgASgLMiYuY3JlYXRpdmVmYWJyaWNhLnByZXNldC52MS5Nb2RlbENvbmZpZxI6Cgtjb2luX2NvbmZpZxgFIAEoCzIlLmNyZWF0aXZlZmFicmljYS5wcmVzZXQudjEuQ29pbkNvbmZpZyryAgoITW9kYWxpdHkSGAoUTU9EQUxJVFlfVU5TUEVDSUZJRUQQABIaChZNT0RBTElUWV9URVhUX1RPX0lNQUdFEAESGwoXTU9EQUxJVFlfSU1BR0VfVE9fSU1BR0UQAhIaChZNT0RBTElUWV9URVhUX1RPX0FVRElPEAMSGgoWTU9EQUxJVFlfVEVYVF9UT19WSURFTxAEEhkKFU1PREFMSVRZX1RFWFRfVE9fVEVYVBAFEhoKFk1PREFMSVRZX0lNQUdFX1RPX1RFWFQQBhIYChRNT0RBTElUWV9JTUFHRV9UT18zRBAHEhsKF01PREFMSVRZX01FRElBX1RPX1ZJREVPEAgSGgoWTU9EQUxJVFlfTUVESUFfVE9fVEVYVBAJEhcKE01PREFMSVRZX1RFWFRfVE9fM0QQChIbChdNT0RBTElUWV9NRURJQV9UT19BVURJTxALEhsKF01PREFMSVRZX01FRElBX1RPX0lNQUdFEAwqvQEKCk91dHB1dFR5cGUSGwoXT1VUUFVUX1RZUEVfVU5TUEVDSUZJRUQQABIVChFPVVRQVVRfVFlQRV9JTUFHRRABEhUKEU9VVFBVVF9UWVBFX0FVRElPEAISFQoRT1VUUFVUX1RZUEVfVklERU8QAxIYChRPVVRQVVRfVFlQRV8zRF9NT0RFTBAEEhQKEE9VVFBVVF9UWVBFX1RFWFQQBRIdChlPVVRQVVRfVFlQRV9MQVlFUkVEX0lNQUdFEAYqxwEKE1ByZXNldFZlcnNpb25TdGF0dXMSJQohUFJFU0VUX1ZFUlNJT05fU1RBVFVTX1VOU1BFQ0lGSUVEEAASHwobUFJFU0VUX1ZFUlNJT05fU1RBVFVTX0RSQUZUEAESIAocUFJFU0VUX1ZFUlNJT05fU1RBVFVTX0FDVElWRRACEiIKHlBSRVNFVF9WRVJTSU9OX1NUQVRVU19BUkNISVZFRBADEiIKHlBSRVNFVF9WRVJTSU9OX1NUQVRVU19JTkFDVElWRRAEKnEKD0NvaW5QcmljaW5nVHlwZRIhCh1DT0lOX1BSSUNJTkdfVFlQRV9VTlNQRUNJRklFRBAAEhwKGENPSU5fUFJJQ0lOR19UWVBFX1NUQVRJQxABEh0KGUNPSU5fUFJJQ0lOR19UWVBFX0RZTkFNSUMQAiqfAQoQU3lzdGVtUHJvbXB0VHlwZRIiCh5TWVNURU1fUFJPTVBUX1RZUEVfVU5TUEVDSUZJRUQQABIdChlTWVNURU1fUFJPTVBUX1RZUEVfU1RBVElDEAESHwobU1lTVEVNX1BST01QVF9UWVBFX1RFTVBMQVRFEAISJwojU1lTVEVNX1BST01QVF9UWVBFX0dPX1RFWFRfVEVNUExBVEUQA0JQWk5naXRodWIuY29tL2NyZWF0aXZlZmFicmljYS9zY2hlbWFzL3BrZy9nZW4vY3JlYXRpdmVmYWJyaWNhL3ByZXNldC92MTtwcmVzZXRfdjFiBnByb3RvMw", [file_creativefabrica_common_v1_surface_v1_types, file_google_protobuf_struct]);

/**
 * FieldValue is a strictly typed container for user-provided input values.
 * Only JSON primitives are accepted — objects, arrays, and null are rejected.
 *
 * JSON examples:
 *   { "stringValue": "bold" }
 *   { "integerValue": "10" }       ← int64 serialises as string in protojson
 *   { "floatValue": 0.7 }
 *   { "booleanValue": true }
 *
 * @generated from message creativefabrica.preset.v1.FieldValue
 */
export type FieldValue = Message<"creativefabrica.preset.v1.FieldValue"> & {
  /**
   * @generated from oneof creativefabrica.preset.v1.FieldValue.value
   */
  value: {
    /**
     * @generated from field: string string_value = 1;
     */
    value: string;
    case: "stringValue";
  } | {
    /**
     * @generated from field: int64 integer_value = 2;
     */
    value: bigint;
    case: "integerValue";
  } | {
    /**
     * @generated from field: double float_value = 3;
     */
    value: number;
    case: "floatValue";
  } | {
    /**
     * @generated from field: bool boolean_value = 4;
     */
    value: boolean;
    case: "booleanValue";
  } | {
    /**
     * @generated from field: creativefabrica.preset.v1.FieldValue.ObjectValue object_value = 5;
     */
    value: FieldValue_ObjectValue;
    case: "objectValue";
  } | {
    /**
     * @generated from field: creativefabrica.preset.v1.FieldValue.ArrayValue array_value = 6;
     */
    value: FieldValue_ArrayValue;
    case: "arrayValue";
  } | { case: undefined; value?: undefined };
};

/**
 * FieldValue is a strictly typed container for user-provided input values.
 * Only JSON primitives are accepted — objects, arrays, and null are rejected.
 *
 * JSON examples:
 *   { "stringValue": "bold" }
 *   { "integerValue": "10" }       ← int64 serialises as string in protojson
 *   { "floatValue": 0.7 }
 *   { "booleanValue": true }
 *
 * @generated from message creativefabrica.preset.v1.FieldValue
 */
export type FieldValueJson = {
  /**
   * @generated from field: string string_value = 1;
   */
  stringValue?: string;

  /**
   * @generated from field: int64 integer_value = 2;
   */
  integerValue?: string;

  /**
   * @generated from field: double float_value = 3;
   */
  floatValue?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: bool boolean_value = 4;
   */
  booleanValue?: boolean;

  /**
   * @generated from field: creativefabrica.preset.v1.FieldValue.ObjectValue object_value = 5;
   */
  objectValue?: FieldValue_ObjectValueJson;

  /**
   * @generated from field: creativefabrica.preset.v1.FieldValue.ArrayValue array_value = 6;
   */
  arrayValue?: FieldValue_ArrayValueJson;
};

/**
 * Describes the message creativefabrica.preset.v1.FieldValue.
 * Use `create(FieldValueSchema)` to create a new message.
 */
export const FieldValueSchema: GenMessage<FieldValue, {jsonType: FieldValueJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_types, 0);

/**
 * @generated from message creativefabrica.preset.v1.FieldValue.ObjectValue
 */
export type FieldValue_ObjectValue = Message<"creativefabrica.preset.v1.FieldValue.ObjectValue"> & {
  /**
   * @generated from field: map<string, creativefabrica.preset.v1.FieldValue> fields = 1;
   */
  fields: { [key: string]: FieldValue };
};

/**
 * @generated from message creativefabrica.preset.v1.FieldValue.ObjectValue
 */
export type FieldValue_ObjectValueJson = {
  /**
   * @generated from field: map<string, creativefabrica.preset.v1.FieldValue> fields = 1;
   */
  fields?: { [key: string]: FieldValueJson };
};

/**
 * Describes the message creativefabrica.preset.v1.FieldValue.ObjectValue.
 * Use `create(FieldValue_ObjectValueSchema)` to create a new message.
 */
export const FieldValue_ObjectValueSchema: GenMessage<FieldValue_ObjectValue, {jsonType: FieldValue_ObjectValueJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_types, 0, 0);

/**
 * @generated from message creativefabrica.preset.v1.FieldValue.ArrayValue
 */
export type FieldValue_ArrayValue = Message<"creativefabrica.preset.v1.FieldValue.ArrayValue"> & {
  /**
   * @generated from field: repeated creativefabrica.preset.v1.FieldValue items = 1;
   */
  items: FieldValue[];
};

/**
 * @generated from message creativefabrica.preset.v1.FieldValue.ArrayValue
 */
export type FieldValue_ArrayValueJson = {
  /**
   * @generated from field: repeated creativefabrica.preset.v1.FieldValue items = 1;
   */
  items?: FieldValueJson[];
};

/**
 * Describes the message creativefabrica.preset.v1.FieldValue.ArrayValue.
 * Use `create(FieldValue_ArrayValueSchema)` to create a new message.
 */
export const FieldValue_ArrayValueSchema: GenMessage<FieldValue_ArrayValue, {jsonType: FieldValue_ArrayValueJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_types, 0, 1);

/**
 * FieldDescriptor describes a single field — used for form rendering,
 * validation, and as the schema definition in SystemPrompt and ModelConfig.
 *
 * @generated from message creativefabrica.preset.v1.FieldDescriptor
 */
export type FieldDescriptor = Message<"creativefabrica.preset.v1.FieldDescriptor"> & {
  /**
   * @generated from field: bool required = 1;
   */
  required: boolean;

  /**
   * display hint, e.g. "seconds", "px"
   *
   * @generated from field: string unit = 2;
   */
  unit: string;

  /**
   * @generated from oneof creativefabrica.preset.v1.FieldDescriptor.type
   */
  type: {
    /**
     * @generated from field: creativefabrica.preset.v1.StringFieldType string_type = 3;
     */
    value: StringFieldType;
    case: "stringType";
  } | {
    /**
     * @generated from field: creativefabrica.preset.v1.IntegerFieldType integer_type = 4;
     */
    value: IntegerFieldType;
    case: "integerType";
  } | {
    /**
     * @generated from field: creativefabrica.preset.v1.FloatFieldType float_type = 5;
     */
    value: FloatFieldType;
    case: "floatType";
  } | {
    /**
     * @generated from field: creativefabrica.preset.v1.BooleanFieldType boolean_type = 6;
     */
    value: BooleanFieldType;
    case: "booleanType";
  } | {
    /**
     * @generated from field: creativefabrica.preset.v1.ObjectFieldType object_type = 7;
     */
    value: ObjectFieldType;
    case: "objectType";
  } | {
    /**
     * @generated from field: creativefabrica.preset.v1.ArrayFieldType array_type = 8;
     */
    value: ArrayFieldType;
    case: "arrayType";
  } | { case: undefined; value?: undefined };

  /**
   * Deprecation marker for renamed options that stay accepted as aliases
   * (e.g. genAI's kling_v3 `mode` → `resolution`). When true, clients should
   * render/submit the option named in replaced_by instead; the server keeps
   * accepting this field's name and rewrites it at ingress. A deprecated
   * option cannot be combined with its replacement in one request.
   *
   * @generated from field: bool deprecated = 9;
   */
  deprecated: boolean;

  /**
   * Canonical option name that supersedes this deprecated one.
   *
   * @generated from field: optional string replaced_by = 10;
   */
  replacedBy?: string | undefined;

  /**
   * Legacy value → canonical value translation (e.g. "std" → "720p"), so
   * clients can migrate stored selections programmatically. Only populated
   * on deprecated string options.
   *
   * @generated from field: map<string, string> deprecated_value_map = 11;
   */
  deprecatedValueMap: { [key: string]: string };
};

/**
 * FieldDescriptor describes a single field — used for form rendering,
 * validation, and as the schema definition in SystemPrompt and ModelConfig.
 *
 * @generated from message creativefabrica.preset.v1.FieldDescriptor
 */
export type FieldDescriptorJson = {
  /**
   * @generated from field: bool required = 1;
   */
  required?: boolean;

  /**
   * display hint, e.g. "seconds", "px"
   *
   * @generated from field: string unit = 2;
   */
  unit?: string;

  /**
   * @generated from field: creativefabrica.preset.v1.StringFieldType string_type = 3;
   */
  stringType?: StringFieldTypeJson;

  /**
   * @generated from field: creativefabrica.preset.v1.IntegerFieldType integer_type = 4;
   */
  integerType?: IntegerFieldTypeJson;

  /**
   * @generated from field: creativefabrica.preset.v1.FloatFieldType float_type = 5;
   */
  floatType?: FloatFieldTypeJson;

  /**
   * @generated from field: creativefabrica.preset.v1.BooleanFieldType boolean_type = 6;
   */
  booleanType?: BooleanFieldTypeJson;

  /**
   * @generated from field: creativefabrica.preset.v1.ObjectFieldType object_type = 7;
   */
  objectType?: ObjectFieldTypeJson;

  /**
   * @generated from field: creativefabrica.preset.v1.ArrayFieldType array_type = 8;
   */
  arrayType?: ArrayFieldTypeJson;

  /**
   * Deprecation marker for renamed options that stay accepted as aliases
   * (e.g. genAI's kling_v3 `mode` → `resolution`). When true, clients should
   * render/submit the option named in replaced_by instead; the server keeps
   * accepting this field's name and rewrites it at ingress. A deprecated
   * option cannot be combined with its replacement in one request.
   *
   * @generated from field: bool deprecated = 9;
   */
  deprecated?: boolean;

  /**
   * Canonical option name that supersedes this deprecated one.
   *
   * @generated from field: optional string replaced_by = 10;
   */
  replacedBy?: string;

  /**
   * Legacy value → canonical value translation (e.g. "std" → "720p"), so
   * clients can migrate stored selections programmatically. Only populated
   * on deprecated string options.
   *
   * @generated from field: map<string, string> deprecated_value_map = 11;
   */
  deprecatedValueMap?: { [key: string]: string };
};

/**
 * Describes the message creativefabrica.preset.v1.FieldDescriptor.
 * Use `create(FieldDescriptorSchema)` to create a new message.
 */
export const FieldDescriptorSchema: GenMessage<FieldDescriptor, {jsonType: FieldDescriptorJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_types, 1);

/**
 * @generated from message creativefabrica.preset.v1.StringFieldType
 */
export type StringFieldType = Message<"creativefabrica.preset.v1.StringFieldType"> & {
  /**
   * enum equivalent
   *
   * @generated from field: repeated string allowed_values = 1;
   */
  allowedValues: string[];

  /**
   * @generated from field: optional string default_value = 2;
   */
  defaultValue?: string | undefined;

  /**
   * @generated from field: optional int32 min_length = 3;
   */
  minLength?: number | undefined;

  /**
   * @generated from field: optional int32 max_length = 4;
   */
  maxLength?: number | undefined;

  /**
   * Server-only key→phrase map applied at template-hydration time.
   * Keys MUST be a subset of allowed_values (validated at preset write).
   * Values that have no entry here are substituted literally — graceful
   * fallback for partial expansion sets.
   *
   * SECURITY: this field is stripped from public reads
   * (PresetService.GetPresetOptions) so prompt-engineering text never
   * crosses the FE boundary. It IS returned by PresetAdminService reads
   * for admin tooling. See preset/server scrubExpansions().
   *
   * @generated from field: map<string, string> value_expansions = 5;
   */
  valueExpansions: { [key: string]: string };
};

/**
 * @generated from message creativefabrica.preset.v1.StringFieldType
 */
export type StringFieldTypeJson = {
  /**
   * enum equivalent
   *
   * @generated from field: repeated string allowed_values = 1;
   */
  allowedValues?: string[];

  /**
   * @generated from field: optional string default_value = 2;
   */
  defaultValue?: string;

  /**
   * @generated from field: optional int32 min_length = 3;
   */
  minLength?: number;

  /**
   * @generated from field: optional int32 max_length = 4;
   */
  maxLength?: number;

  /**
   * Server-only key→phrase map applied at template-hydration time.
   * Keys MUST be a subset of allowed_values (validated at preset write).
   * Values that have no entry here are substituted literally — graceful
   * fallback for partial expansion sets.
   *
   * SECURITY: this field is stripped from public reads
   * (PresetService.GetPresetOptions) so prompt-engineering text never
   * crosses the FE boundary. It IS returned by PresetAdminService reads
   * for admin tooling. See preset/server scrubExpansions().
   *
   * @generated from field: map<string, string> value_expansions = 5;
   */
  valueExpansions?: { [key: string]: string };
};

/**
 * Describes the message creativefabrica.preset.v1.StringFieldType.
 * Use `create(StringFieldTypeSchema)` to create a new message.
 */
export const StringFieldTypeSchema: GenMessage<StringFieldType, {jsonType: StringFieldTypeJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_types, 2);

/**
 * @generated from message creativefabrica.preset.v1.IntegerFieldType
 */
export type IntegerFieldType = Message<"creativefabrica.preset.v1.IntegerFieldType"> & {
  /**
   * enum equivalent
   *
   * @generated from field: repeated int64 allowed_values = 1;
   */
  allowedValues: bigint[];

  /**
   * @generated from field: optional int64 default_value = 2;
   */
  defaultValue?: bigint | undefined;

  /**
   * @generated from field: optional int64 min = 3;
   */
  min?: bigint | undefined;

  /**
   * @generated from field: optional int64 max = 4;
   */
  max?: bigint | undefined;
};

/**
 * @generated from message creativefabrica.preset.v1.IntegerFieldType
 */
export type IntegerFieldTypeJson = {
  /**
   * enum equivalent
   *
   * @generated from field: repeated int64 allowed_values = 1;
   */
  allowedValues?: string[];

  /**
   * @generated from field: optional int64 default_value = 2;
   */
  defaultValue?: string;

  /**
   * @generated from field: optional int64 min = 3;
   */
  min?: string;

  /**
   * @generated from field: optional int64 max = 4;
   */
  max?: string;
};

/**
 * Describes the message creativefabrica.preset.v1.IntegerFieldType.
 * Use `create(IntegerFieldTypeSchema)` to create a new message.
 */
export const IntegerFieldTypeSchema: GenMessage<IntegerFieldType, {jsonType: IntegerFieldTypeJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_types, 3);

/**
 * @generated from message creativefabrica.preset.v1.FloatFieldType
 */
export type FloatFieldType = Message<"creativefabrica.preset.v1.FloatFieldType"> & {
  /**
   * @generated from field: optional double default_value = 1;
   */
  defaultValue?: number | undefined;

  /**
   * @generated from field: optional double min = 2;
   */
  min?: number | undefined;

  /**
   * @generated from field: optional double max = 3;
   */
  max?: number | undefined;
};

/**
 * @generated from message creativefabrica.preset.v1.FloatFieldType
 */
export type FloatFieldTypeJson = {
  /**
   * @generated from field: optional double default_value = 1;
   */
  defaultValue?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double min = 2;
   */
  min?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double max = 3;
   */
  max?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message creativefabrica.preset.v1.FloatFieldType.
 * Use `create(FloatFieldTypeSchema)` to create a new message.
 */
export const FloatFieldTypeSchema: GenMessage<FloatFieldType, {jsonType: FloatFieldTypeJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_types, 4);

/**
 * @generated from message creativefabrica.preset.v1.BooleanFieldType
 */
export type BooleanFieldType = Message<"creativefabrica.preset.v1.BooleanFieldType"> & {
  /**
   * @generated from field: optional bool default_value = 1;
   */
  defaultValue?: boolean | undefined;
};

/**
 * @generated from message creativefabrica.preset.v1.BooleanFieldType
 */
export type BooleanFieldTypeJson = {
  /**
   * @generated from field: optional bool default_value = 1;
   */
  defaultValue?: boolean;
};

/**
 * Describes the message creativefabrica.preset.v1.BooleanFieldType.
 * Use `create(BooleanFieldTypeSchema)` to create a new message.
 */
export const BooleanFieldTypeSchema: GenMessage<BooleanFieldType, {jsonType: BooleanFieldTypeJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_types, 5);

/**
 * @generated from message creativefabrica.preset.v1.ObjectFieldType
 */
export type ObjectFieldType = Message<"creativefabrica.preset.v1.ObjectFieldType"> & {
  /**
   * @generated from field: map<string, creativefabrica.preset.v1.FieldDescriptor> properties = 1;
   */
  properties: { [key: string]: FieldDescriptor };
};

/**
 * @generated from message creativefabrica.preset.v1.ObjectFieldType
 */
export type ObjectFieldTypeJson = {
  /**
   * @generated from field: map<string, creativefabrica.preset.v1.FieldDescriptor> properties = 1;
   */
  properties?: { [key: string]: FieldDescriptorJson };
};

/**
 * Describes the message creativefabrica.preset.v1.ObjectFieldType.
 * Use `create(ObjectFieldTypeSchema)` to create a new message.
 */
export const ObjectFieldTypeSchema: GenMessage<ObjectFieldType, {jsonType: ObjectFieldTypeJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_types, 6);

/**
 * @generated from message creativefabrica.preset.v1.ArrayFieldType
 */
export type ArrayFieldType = Message<"creativefabrica.preset.v1.ArrayFieldType"> & {
  /**
   * @generated from field: creativefabrica.preset.v1.FieldDescriptor items = 1;
   */
  items?: FieldDescriptor | undefined;
};

/**
 * @generated from message creativefabrica.preset.v1.ArrayFieldType
 */
export type ArrayFieldTypeJson = {
  /**
   * @generated from field: creativefabrica.preset.v1.FieldDescriptor items = 1;
   */
  items?: FieldDescriptorJson;
};

/**
 * Describes the message creativefabrica.preset.v1.ArrayFieldType.
 * Use `create(ArrayFieldTypeSchema)` to create a new message.
 */
export const ArrayFieldTypeSchema: GenMessage<ArrayFieldType, {jsonType: ArrayFieldTypeJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_types, 7);

/**
 * CoinConfig defines the billing price for a specific model config.
 *
 * @generated from message creativefabrica.preset.v1.CoinConfig
 */
export type CoinConfig = Message<"creativefabrica.preset.v1.CoinConfig"> & {
  /**
   * e.g. "standard"
   *
   * @generated from field: string coin_type = 1;
   */
  coinType: string;

  /**
   * @generated from field: creativefabrica.preset.v1.CoinPricingType pricing_type = 2;
   */
  pricingType: CoinPricingType;

  /**
   * set for STATIC; omitted for DYNAMIC (resolved at runtime)
   *
   * @generated from field: optional int32 coin_amount = 3;
   */
  coinAmount?: number | undefined;
};

/**
 * CoinConfig defines the billing price for a specific model config.
 *
 * @generated from message creativefabrica.preset.v1.CoinConfig
 */
export type CoinConfigJson = {
  /**
   * e.g. "standard"
   *
   * @generated from field: string coin_type = 1;
   */
  coinType?: string;

  /**
   * @generated from field: creativefabrica.preset.v1.CoinPricingType pricing_type = 2;
   */
  pricingType?: CoinPricingTypeJson;

  /**
   * set for STATIC; omitted for DYNAMIC (resolved at runtime)
   *
   * @generated from field: optional int32 coin_amount = 3;
   */
  coinAmount?: number;
};

/**
 * Describes the message creativefabrica.preset.v1.CoinConfig.
 * Use `create(CoinConfigSchema)` to create a new message.
 */
export const CoinConfigSchema: GenMessage<CoinConfig, {jsonType: CoinConfigJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_types, 8);

/**
 * PresetSummary is lightweight preset metadata for discovery.
 * No model configs — call GetPresetOptions for the full form config.
 *
 * @generated from message creativefabrica.preset.v1.PresetSummary
 */
export type PresetSummary = Message<"creativefabrica.preset.v1.PresetSummary"> & {
  /**
   * @generated from field: string preset_id = 1;
   */
  presetId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: creativefabrica.preset.v1.Modality modality = 3;
   */
  modality: Modality;

  /**
   * @generated from field: creativefabrica.preset.v1.OutputType output_type = 4;
   */
  outputType: OutputType;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: repeated string tags = 6;
   */
  tags: string[];

  /**
   * @generated from field: repeated creativefabrica.common.v1.surface.v1.Surface surfaces = 8;
   */
  surfaces: Surface[];
};

/**
 * PresetSummary is lightweight preset metadata for discovery.
 * No model configs — call GetPresetOptions for the full form config.
 *
 * @generated from message creativefabrica.preset.v1.PresetSummary
 */
export type PresetSummaryJson = {
  /**
   * @generated from field: string preset_id = 1;
   */
  presetId?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: creativefabrica.preset.v1.Modality modality = 3;
   */
  modality?: ModalityJson;

  /**
   * @generated from field: creativefabrica.preset.v1.OutputType output_type = 4;
   */
  outputType?: OutputTypeJson;

  /**
   * @generated from field: string description = 5;
   */
  description?: string;

  /**
   * @generated from field: repeated string tags = 6;
   */
  tags?: string[];

  /**
   * @generated from field: repeated creativefabrica.common.v1.surface.v1.Surface surfaces = 8;
   */
  surfaces?: SurfaceJson[];
};

/**
 * Describes the message creativefabrica.preset.v1.PresetSummary.
 * Use `create(PresetSummarySchema)` to create a new message.
 */
export const PresetSummarySchema: GenMessage<PresetSummary, {jsonType: PresetSummaryJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_types, 9);

/**
 * PresetModelInfo describes a model available for a preset version.
 *
 * @generated from message creativefabrica.preset.v1.PresetModelInfo
 */
export type PresetModelInfo = Message<"creativefabrica.preset.v1.PresetModelInfo"> & {
  /**
   * @generated from field: string model = 1;
   */
  model: string;

  /**
   * @generated from field: string provider = 2;
   */
  provider: string;

  /**
   * @generated from field: bool is_default = 3;
   */
  isDefault: boolean;

  /**
   * @generated from field: creativefabrica.preset.v1.CoinConfig coin_config = 4;
   */
  coinConfig?: CoinConfig | undefined;
};

/**
 * PresetModelInfo describes a model available for a preset version.
 *
 * @generated from message creativefabrica.preset.v1.PresetModelInfo
 */
export type PresetModelInfoJson = {
  /**
   * @generated from field: string model = 1;
   */
  model?: string;

  /**
   * @generated from field: string provider = 2;
   */
  provider?: string;

  /**
   * @generated from field: bool is_default = 3;
   */
  isDefault?: boolean;

  /**
   * @generated from field: creativefabrica.preset.v1.CoinConfig coin_config = 4;
   */
  coinConfig?: CoinConfigJson;
};

/**
 * Describes the message creativefabrica.preset.v1.PresetModelInfo.
 * Use `create(PresetModelInfoSchema)` to create a new message.
 */
export const PresetModelInfoSchema: GenMessage<PresetModelInfo, {jsonType: PresetModelInfoJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_types, 10);

/**
 * SystemPrompt defines the prompt configuration for a preset version.
 *
 * @generated from message creativefabrica.preset.v1.SystemPrompt
 */
export type SystemPrompt = Message<"creativefabrica.preset.v1.SystemPrompt"> & {
  /**
   * @generated from field: creativefabrica.preset.v1.SystemPromptType type = 1;
   */
  type: SystemPromptType;

  /**
   * prompt text, may contain {{variable}} placeholders
   *
   * @generated from field: string text = 2;
   */
  text: string;

  /**
   * Template variable definitions — only present when type = SYSTEM_PROMPT_TYPE_TEMPLATE.
   * Each entry describes a variable that appears as {{key}} in the prompt text.
   * Validated at write time: every {{placeholder}} in text must have a matching entry.
   *
   * @generated from field: map<string, creativefabrica.preset.v1.FieldDescriptor> variables = 3;
   */
  variables: { [key: string]: FieldDescriptor };
};

/**
 * SystemPrompt defines the prompt configuration for a preset version.
 *
 * @generated from message creativefabrica.preset.v1.SystemPrompt
 */
export type SystemPromptJson = {
  /**
   * @generated from field: creativefabrica.preset.v1.SystemPromptType type = 1;
   */
  type?: SystemPromptTypeJson;

  /**
   * prompt text, may contain {{variable}} placeholders
   *
   * @generated from field: string text = 2;
   */
  text?: string;

  /**
   * Template variable definitions — only present when type = SYSTEM_PROMPT_TYPE_TEMPLATE.
   * Each entry describes a variable that appears as {{key}} in the prompt text.
   * Validated at write time: every {{placeholder}} in text must have a matching entry.
   *
   * @generated from field: map<string, creativefabrica.preset.v1.FieldDescriptor> variables = 3;
   */
  variables?: { [key: string]: FieldDescriptorJson };
};

/**
 * Describes the message creativefabrica.preset.v1.SystemPrompt.
 * Use `create(SystemPromptSchema)` to create a new message.
 */
export const SystemPromptSchema: GenMessage<SystemPrompt, {jsonType: SystemPromptJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_types, 11);

/**
 * ModelConfig defines provider-specific configuration for a model within a preset version.
 *
 * @generated from message creativefabrica.preset.v1.ModelConfig
 */
export type ModelConfig = Message<"creativefabrica.preset.v1.ModelConfig"> & {
  /**
   * Parameters sent to the AI provider (temperature, top_p, cfg_scale, etc.).
   * Not user-facing — these are fixed per preset version model config.
   *
   * @generated from field: map<string, creativefabrica.preset.v1.FieldValue> provider_params = 1;
   */
  providerParams: { [key: string]: FieldValue };

  /**
   * User-selectable parameters the FE renders as form controls
   * (e.g. duration_seconds, aspect_ratio, output_format).
   * A narrowed subset of the model's general capabilities for this preset.
   *
   * @generated from field: map<string, creativefabrica.preset.v1.FieldDescriptor> input_options = 2;
   */
  inputOptions: { [key: string]: FieldDescriptor };

  /**
   * Flat per-file limits for modalities with a single homogeneous input bucket
   * (e.g. image_to_image, image_to_text). Keys are well-known limit names
   * (max_images, accepted_formats, max_file_size_mb). Empty for role-keyed
   * modalities — see input_role_constraints.
   *
   * @generated from field: map<string, creativefabrica.preset.v1.FieldDescriptor> input_constraints = 3;
   */
  inputConstraints: { [key: string]: FieldDescriptor };

  /**
   * Expected structure of the provider's response. Only set for modalities
   * that return structured data (image_to_text, text_to_text).
   * The worker validates the provider response against this.
   *
   * @generated from field: creativefabrica.preset.v1.FieldDescriptor output_schema = 4;
   */
  outputSchema?: FieldDescriptor | undefined;

  /**
   * Per-role file limits for modalities that accept heterogeneous inputs
   * (e.g. media_to_video with firstFrame / lastFrame / reference*). Keys are
   * role names; values are typed RoleConstraint blocks the FE renders directly.
   * Empty for flat-file modalities.
   *
   * @generated from field: map<string, creativefabrica.preset.v1.RoleConstraint> input_role_constraints = 5;
   */
  inputRoleConstraints: { [key: string]: RoleConstraint };

  /**
   * Cross-role validation rules. Evaluated by the service before dispatch.
   * `type` is the rule discriminator (e.g. "mutuallyExclusive", "requires",
   * "totalMax", "totalMaxDuration"); `params` shape is per-type.
   * Empty when no cross-role constraints apply.
   *
   * @generated from field: repeated creativefabrica.preset.v1.ConstraintRule input_constraint_rules = 6;
   */
  inputConstraintRules: ConstraintRule[];

  /**
   * JSON Schema passed verbatim to providers that support structured-output
   * configuration (e.g. Gemini's responseJsonSchema). Stored as Struct so the
   * full JSON Schema vocabulary survives the round-trip — $ref, $defs,
   * additionalProperties, minItems / maxItems, description — none of which
   * FieldDescriptor (above, output_schema) can express. The worker passes
   * this map straight to the provider SDK; no server-side translation.
   *
   * @generated from field: google.protobuf.Struct response_json_schema = 7;
   */
  responseJsonSchema?: JsonObject | undefined;
};

/**
 * ModelConfig defines provider-specific configuration for a model within a preset version.
 *
 * @generated from message creativefabrica.preset.v1.ModelConfig
 */
export type ModelConfigJson = {
  /**
   * Parameters sent to the AI provider (temperature, top_p, cfg_scale, etc.).
   * Not user-facing — these are fixed per preset version model config.
   *
   * @generated from field: map<string, creativefabrica.preset.v1.FieldValue> provider_params = 1;
   */
  providerParams?: { [key: string]: FieldValueJson };

  /**
   * User-selectable parameters the FE renders as form controls
   * (e.g. duration_seconds, aspect_ratio, output_format).
   * A narrowed subset of the model's general capabilities for this preset.
   *
   * @generated from field: map<string, creativefabrica.preset.v1.FieldDescriptor> input_options = 2;
   */
  inputOptions?: { [key: string]: FieldDescriptorJson };

  /**
   * Flat per-file limits for modalities with a single homogeneous input bucket
   * (e.g. image_to_image, image_to_text). Keys are well-known limit names
   * (max_images, accepted_formats, max_file_size_mb). Empty for role-keyed
   * modalities — see input_role_constraints.
   *
   * @generated from field: map<string, creativefabrica.preset.v1.FieldDescriptor> input_constraints = 3;
   */
  inputConstraints?: { [key: string]: FieldDescriptorJson };

  /**
   * Expected structure of the provider's response. Only set for modalities
   * that return structured data (image_to_text, text_to_text).
   * The worker validates the provider response against this.
   *
   * @generated from field: creativefabrica.preset.v1.FieldDescriptor output_schema = 4;
   */
  outputSchema?: FieldDescriptorJson;

  /**
   * Per-role file limits for modalities that accept heterogeneous inputs
   * (e.g. media_to_video with firstFrame / lastFrame / reference*). Keys are
   * role names; values are typed RoleConstraint blocks the FE renders directly.
   * Empty for flat-file modalities.
   *
   * @generated from field: map<string, creativefabrica.preset.v1.RoleConstraint> input_role_constraints = 5;
   */
  inputRoleConstraints?: { [key: string]: RoleConstraintJson };

  /**
   * Cross-role validation rules. Evaluated by the service before dispatch.
   * `type` is the rule discriminator (e.g. "mutuallyExclusive", "requires",
   * "totalMax", "totalMaxDuration"); `params` shape is per-type.
   * Empty when no cross-role constraints apply.
   *
   * @generated from field: repeated creativefabrica.preset.v1.ConstraintRule input_constraint_rules = 6;
   */
  inputConstraintRules?: ConstraintRuleJson[];

  /**
   * JSON Schema passed verbatim to providers that support structured-output
   * configuration (e.g. Gemini's responseJsonSchema). Stored as Struct so the
   * full JSON Schema vocabulary survives the round-trip — $ref, $defs,
   * additionalProperties, minItems / maxItems, description — none of which
   * FieldDescriptor (above, output_schema) can express. The worker passes
   * this map straight to the provider SDK; no server-side translation.
   *
   * @generated from field: google.protobuf.Struct response_json_schema = 7;
   */
  responseJsonSchema?: StructJson;
};

/**
 * Describes the message creativefabrica.preset.v1.ModelConfig.
 * Use `create(ModelConfigSchema)` to create a new message.
 */
export const ModelConfigSchema: GenMessage<ModelConfig, {jsonType: ModelConfigJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_types, 12);

/**
 * RoleConstraint describes per-file limits for a single named role
 * (e.g. "firstFrame", "referenceImage", "referenceAudio", "referenceVideo").
 * Physical media properties — stable across providers.
 *
 * @generated from message creativefabrica.preset.v1.RoleConstraint
 */
export type RoleConstraint = Message<"creativefabrica.preset.v1.RoleConstraint"> & {
  /**
   * Maximum number of files allowed for this role.
   *
   * @generated from field: int32 max = 1;
   */
  max: number;

  /**
   * Minimum number of files required for this role. 0 means optional; 1 makes
   * the role mandatory (e.g. an image-edit model's source image, or
   * wan_2_7_spicy's sourceImage). Mirrors the registry's role min so clients can
   * mark the input as required.
   *
   * @generated from field: int32 min = 8;
   */
  min: number;

  /**
   * Allowed MIME types (e.g. "image/png", "audio/mpeg", "video/mp4").
   *
   * @generated from field: repeated string accepted_formats = 2;
   */
  acceptedFormats: string[];

  /**
   * Per-file size cap in megabytes.
   *
   * @generated from field: int32 max_file_size_mb = 3;
   */
  maxFileSizeMb: number;

  /**
   * Duration bounds — only meaningful for audio / video roles.
   *
   * @generated from field: optional int32 min_duration_seconds = 4;
   */
  minDurationSeconds?: number | undefined;

  /**
   * @generated from field: optional int32 max_duration_seconds = 5;
   */
  maxDurationSeconds?: number | undefined;

  /**
   * Frame-rate bounds — video roles only, checked against the probed frame rate.
   *
   * @generated from field: optional int32 min_fps = 11;
   */
  minFps?: number | undefined;

  /**
   * @generated from field: optional int32 max_fps = 12;
   */
  maxFps?: number | undefined;

  /**
   * Geometric bounds — only meaningful for visual roles (image, video).
   *
   * @generated from field: optional creativefabrica.preset.v1.DimensionConstraint dimensions = 6;
   */
  dimensions?: DimensionConstraint | undefined;

  /**
   * Declares the provider routing metadata keys accepted for files in this role,
   * keyed by property name. Each value is a FieldDescriptor describing the key's
   * type, allowed values and default — reusing the input_options shape. The
   * client sends matching pairs in InputFile.provider_metadata; the server
   * validates them against this declaration and applies the declared default for
   * any absent key. e.g. "reference_type" -> string enum {subject, background},
   * default "background" (PixVerse C1 subject/background references).
   *
   * @generated from field: map<string, creativefabrica.preset.v1.FieldDescriptor> provider_metadata = 7;
   */
  providerMetadata: { [key: string]: FieldDescriptor };

  /**
   * When true, the generation service may crop and/or resize visual media to
   * satisfy the declared dimension bounds before provider dispatch. The
   * original input is preserved. Clients should present this as a non-blocking
   * transformation advisory rather than rejecting an otherwise valid input.
   *
   * @generated from field: bool auto_conform_dimensions = 9;
   */
  autoConformDimensions: boolean;

  /**
   * When true, the generation service may downscale visual media that exceeds
   * max_width_px or max_height_px. Minimum-size and aspect-ratio violations
   * remain errors. The original input is preserved.
   *
   * @generated from field: bool auto_resize_on_overflow = 10;
   */
  autoResizeOnOverflow: boolean;
};

/**
 * RoleConstraint describes per-file limits for a single named role
 * (e.g. "firstFrame", "referenceImage", "referenceAudio", "referenceVideo").
 * Physical media properties — stable across providers.
 *
 * @generated from message creativefabrica.preset.v1.RoleConstraint
 */
export type RoleConstraintJson = {
  /**
   * Maximum number of files allowed for this role.
   *
   * @generated from field: int32 max = 1;
   */
  max?: number;

  /**
   * Minimum number of files required for this role. 0 means optional; 1 makes
   * the role mandatory (e.g. an image-edit model's source image, or
   * wan_2_7_spicy's sourceImage). Mirrors the registry's role min so clients can
   * mark the input as required.
   *
   * @generated from field: int32 min = 8;
   */
  min?: number;

  /**
   * Allowed MIME types (e.g. "image/png", "audio/mpeg", "video/mp4").
   *
   * @generated from field: repeated string accepted_formats = 2;
   */
  acceptedFormats?: string[];

  /**
   * Per-file size cap in megabytes.
   *
   * @generated from field: int32 max_file_size_mb = 3;
   */
  maxFileSizeMb?: number;

  /**
   * Duration bounds — only meaningful for audio / video roles.
   *
   * @generated from field: optional int32 min_duration_seconds = 4;
   */
  minDurationSeconds?: number;

  /**
   * @generated from field: optional int32 max_duration_seconds = 5;
   */
  maxDurationSeconds?: number;

  /**
   * Frame-rate bounds — video roles only, checked against the probed frame rate.
   *
   * @generated from field: optional int32 min_fps = 11;
   */
  minFps?: number;

  /**
   * @generated from field: optional int32 max_fps = 12;
   */
  maxFps?: number;

  /**
   * Geometric bounds — only meaningful for visual roles (image, video).
   *
   * @generated from field: optional creativefabrica.preset.v1.DimensionConstraint dimensions = 6;
   */
  dimensions?: DimensionConstraintJson;

  /**
   * Declares the provider routing metadata keys accepted for files in this role,
   * keyed by property name. Each value is a FieldDescriptor describing the key's
   * type, allowed values and default — reusing the input_options shape. The
   * client sends matching pairs in InputFile.provider_metadata; the server
   * validates them against this declaration and applies the declared default for
   * any absent key. e.g. "reference_type" -> string enum {subject, background},
   * default "background" (PixVerse C1 subject/background references).
   *
   * @generated from field: map<string, creativefabrica.preset.v1.FieldDescriptor> provider_metadata = 7;
   */
  providerMetadata?: { [key: string]: FieldDescriptorJson };

  /**
   * When true, the generation service may crop and/or resize visual media to
   * satisfy the declared dimension bounds before provider dispatch. The
   * original input is preserved. Clients should present this as a non-blocking
   * transformation advisory rather than rejecting an otherwise valid input.
   *
   * @generated from field: bool auto_conform_dimensions = 9;
   */
  autoConformDimensions?: boolean;

  /**
   * When true, the generation service may downscale visual media that exceeds
   * max_width_px or max_height_px. Minimum-size and aspect-ratio violations
   * remain errors. The original input is preserved.
   *
   * @generated from field: bool auto_resize_on_overflow = 10;
   */
  autoResizeOnOverflow?: boolean;
};

/**
 * Describes the message creativefabrica.preset.v1.RoleConstraint.
 * Use `create(RoleConstraintSchema)` to create a new message.
 */
export const RoleConstraintSchema: GenMessage<RoleConstraint, {jsonType: RoleConstraintJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_types, 13);

/**
 * DimensionConstraint expresses geometric limits on visual media.
 * All fields optional; absent = no check on that axis.
 *
 * @generated from message creativefabrica.preset.v1.DimensionConstraint
 */
export type DimensionConstraint = Message<"creativefabrica.preset.v1.DimensionConstraint"> & {
  /**
   * Resolution tier labels the FE can surface as-is (e.g. "480p", "720p", "1080p", "4k").
   *
   * @generated from field: repeated string allowed_resolutions = 1;
   */
  allowedResolutions: string[];

  /**
   * @generated from field: optional int32 min_width_px = 2;
   */
  minWidthPx?: number | undefined;

  /**
   * @generated from field: optional int32 max_width_px = 3;
   */
  maxWidthPx?: number | undefined;

  /**
   * @generated from field: optional int32 min_height_px = 4;
   */
  minHeightPx?: number | undefined;

  /**
   * @generated from field: optional int32 max_height_px = 5;
   */
  maxHeightPx?: number | undefined;

  /**
   * width × height bounds.
   *
   * @generated from field: optional int32 min_frame_pixels = 6;
   */
  minFramePixels?: number | undefined;

  /**
   * @generated from field: optional int32 max_frame_pixels = 7;
   */
  maxFramePixels?: number | undefined;

  /**
   * width ÷ height bounds.
   *
   * @generated from field: optional double min_aspect_ratio = 8;
   */
  minAspectRatio?: number | undefined;

  /**
   * @generated from field: optional double max_aspect_ratio = 9;
   */
  maxAspectRatio?: number | undefined;

  /**
   * Axis-agnostic bounds — applied whichever way round the media is, so a
   * portrait and a landscape clip are held to the same limit.
   *
   * @generated from field: optional int32 min_longer_side_px = 10;
   */
  minLongerSidePx?: number | undefined;

  /**
   * @generated from field: optional int32 max_longer_side_px = 11;
   */
  maxLongerSidePx?: number | undefined;

  /**
   * @generated from field: optional int32 min_shorter_side_px = 12;
   */
  minShorterSidePx?: number | undefined;

  /**
   * @generated from field: optional int32 max_shorter_side_px = 13;
   */
  maxShorterSidePx?: number | undefined;
};

/**
 * DimensionConstraint expresses geometric limits on visual media.
 * All fields optional; absent = no check on that axis.
 *
 * @generated from message creativefabrica.preset.v1.DimensionConstraint
 */
export type DimensionConstraintJson = {
  /**
   * Resolution tier labels the FE can surface as-is (e.g. "480p", "720p", "1080p", "4k").
   *
   * @generated from field: repeated string allowed_resolutions = 1;
   */
  allowedResolutions?: string[];

  /**
   * @generated from field: optional int32 min_width_px = 2;
   */
  minWidthPx?: number;

  /**
   * @generated from field: optional int32 max_width_px = 3;
   */
  maxWidthPx?: number;

  /**
   * @generated from field: optional int32 min_height_px = 4;
   */
  minHeightPx?: number;

  /**
   * @generated from field: optional int32 max_height_px = 5;
   */
  maxHeightPx?: number;

  /**
   * width × height bounds.
   *
   * @generated from field: optional int32 min_frame_pixels = 6;
   */
  minFramePixels?: number;

  /**
   * @generated from field: optional int32 max_frame_pixels = 7;
   */
  maxFramePixels?: number;

  /**
   * width ÷ height bounds.
   *
   * @generated from field: optional double min_aspect_ratio = 8;
   */
  minAspectRatio?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double max_aspect_ratio = 9;
   */
  maxAspectRatio?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * Axis-agnostic bounds — applied whichever way round the media is, so a
   * portrait and a landscape clip are held to the same limit.
   *
   * @generated from field: optional int32 min_longer_side_px = 10;
   */
  minLongerSidePx?: number;

  /**
   * @generated from field: optional int32 max_longer_side_px = 11;
   */
  maxLongerSidePx?: number;

  /**
   * @generated from field: optional int32 min_shorter_side_px = 12;
   */
  minShorterSidePx?: number;

  /**
   * @generated from field: optional int32 max_shorter_side_px = 13;
   */
  maxShorterSidePx?: number;
};

/**
 * Describes the message creativefabrica.preset.v1.DimensionConstraint.
 * Use `create(DimensionConstraintSchema)` to create a new message.
 */
export const DimensionConstraintSchema: GenMessage<DimensionConstraint, {jsonType: DimensionConstraintJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_types, 14);

/**
 * ConstraintRule is a typed cross-role validation rule. Evaluated by the
 * service in declaration order before dispatch. New rule kinds are added by
 * extending the `rule` oneof.
 *
 * @generated from message creativefabrica.preset.v1.ConstraintRule
 */
export type ConstraintRule = Message<"creativefabrica.preset.v1.ConstraintRule"> & {
  /**
   * @generated from oneof creativefabrica.preset.v1.ConstraintRule.rule
   */
  rule: {
    /**
     * @generated from field: creativefabrica.preset.v1.MutuallyExclusiveRule mutually_exclusive = 1;
     */
    value: MutuallyExclusiveRule;
    case: "mutuallyExclusive";
  } | {
    /**
     * @generated from field: creativefabrica.preset.v1.RequiresRule requires = 2;
     */
    value: RequiresRule;
    case: "requires";
  } | {
    /**
     * @generated from field: creativefabrica.preset.v1.TotalMaxRule total_max = 3;
     */
    value: TotalMaxRule;
    case: "totalMax";
  } | {
    /**
     * @generated from field: creativefabrica.preset.v1.TotalMaxDurationRule total_max_duration = 4;
     */
    value: TotalMaxDurationRule;
    case: "totalMaxDuration";
  } | {
    /**
     * @generated from field: creativefabrica.preset.v1.ConditionalMaxOptionRule conditional_max_option = 5;
     */
    value: ConditionalMaxOptionRule;
    case: "conditionalMaxOption";
  } | {
    /**
     * @generated from field: creativefabrica.preset.v1.ConditionalUnavailableOptionsRule conditional_unavailable_options = 6;
     */
    value: ConditionalUnavailableOptionsRule;
    case: "conditionalUnavailableOptions";
  } | {
    /**
     * @generated from field: creativefabrica.preset.v1.TotalMaxMbRule total_max_mb = 7;
     */
    value: TotalMaxMbRule;
    case: "totalMaxMb";
  } | {
    /**
     * @generated from field: creativefabrica.preset.v1.MaxCombinedDurationWithOptionRule max_combined_duration_with_option = 8;
     */
    value: MaxCombinedDurationWithOptionRule;
    case: "maxCombinedDurationWithOption";
  } | {
    /**
     * @generated from field: creativefabrica.preset.v1.ConditionalMinOptionRule conditional_min_option = 9;
     */
    value: ConditionalMinOptionRule;
    case: "conditionalMinOption";
  } | { case: undefined; value?: undefined };
};

/**
 * ConstraintRule is a typed cross-role validation rule. Evaluated by the
 * service in declaration order before dispatch. New rule kinds are added by
 * extending the `rule` oneof.
 *
 * @generated from message creativefabrica.preset.v1.ConstraintRule
 */
export type ConstraintRuleJson = {
  /**
   * @generated from field: creativefabrica.preset.v1.MutuallyExclusiveRule mutually_exclusive = 1;
   */
  mutuallyExclusive?: MutuallyExclusiveRuleJson;

  /**
   * @generated from field: creativefabrica.preset.v1.RequiresRule requires = 2;
   */
  requires?: RequiresRuleJson;

  /**
   * @generated from field: creativefabrica.preset.v1.TotalMaxRule total_max = 3;
   */
  totalMax?: TotalMaxRuleJson;

  /**
   * @generated from field: creativefabrica.preset.v1.TotalMaxDurationRule total_max_duration = 4;
   */
  totalMaxDuration?: TotalMaxDurationRuleJson;

  /**
   * @generated from field: creativefabrica.preset.v1.ConditionalMaxOptionRule conditional_max_option = 5;
   */
  conditionalMaxOption?: ConditionalMaxOptionRuleJson;

  /**
   * @generated from field: creativefabrica.preset.v1.ConditionalUnavailableOptionsRule conditional_unavailable_options = 6;
   */
  conditionalUnavailableOptions?: ConditionalUnavailableOptionsRuleJson;

  /**
   * @generated from field: creativefabrica.preset.v1.TotalMaxMbRule total_max_mb = 7;
   */
  totalMaxMb?: TotalMaxMbRuleJson;

  /**
   * @generated from field: creativefabrica.preset.v1.MaxCombinedDurationWithOptionRule max_combined_duration_with_option = 8;
   */
  maxCombinedDurationWithOption?: MaxCombinedDurationWithOptionRuleJson;

  /**
   * @generated from field: creativefabrica.preset.v1.ConditionalMinOptionRule conditional_min_option = 9;
   */
  conditionalMinOption?: ConditionalMinOptionRuleJson;
};

/**
 * Describes the message creativefabrica.preset.v1.ConstraintRule.
 * Use `create(ConstraintRuleSchema)` to create a new message.
 */
export const ConstraintRuleSchema: GenMessage<ConstraintRule, {jsonType: ConstraintRuleJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_types, 15);

/**
 * No two listed groups may both contain any file.
 * e.g. groups = [[firstFrame, lastFrame], [referenceImage, referenceAudio, referenceVideo]]
 *
 * @generated from message creativefabrica.preset.v1.MutuallyExclusiveRule
 */
export type MutuallyExclusiveRule = Message<"creativefabrica.preset.v1.MutuallyExclusiveRule"> & {
  /**
   * @generated from field: repeated creativefabrica.preset.v1.RoleGroup groups = 1;
   */
  groups: RoleGroup[];
};

/**
 * No two listed groups may both contain any file.
 * e.g. groups = [[firstFrame, lastFrame], [referenceImage, referenceAudio, referenceVideo]]
 *
 * @generated from message creativefabrica.preset.v1.MutuallyExclusiveRule
 */
export type MutuallyExclusiveRuleJson = {
  /**
   * @generated from field: repeated creativefabrica.preset.v1.RoleGroup groups = 1;
   */
  groups?: RoleGroupJson[];
};

/**
 * Describes the message creativefabrica.preset.v1.MutuallyExclusiveRule.
 * Use `create(MutuallyExclusiveRuleSchema)` to create a new message.
 */
export const MutuallyExclusiveRuleSchema: GenMessage<MutuallyExclusiveRule, {jsonType: MutuallyExclusiveRuleJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_types, 16);

/**
 * @generated from message creativefabrica.preset.v1.RoleGroup
 */
export type RoleGroup = Message<"creativefabrica.preset.v1.RoleGroup"> & {
  /**
   * @generated from field: repeated string roles = 1;
   */
  roles: string[];
};

/**
 * @generated from message creativefabrica.preset.v1.RoleGroup
 */
export type RoleGroupJson = {
  /**
   * @generated from field: repeated string roles = 1;
   */
  roles?: string[];
};

/**
 * Describes the message creativefabrica.preset.v1.RoleGroup.
 * Use `create(RoleGroupSchema)` to create a new message.
 */
export const RoleGroupSchema: GenMessage<RoleGroup, {jsonType: RoleGroupJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_types, 17);

/**
 * If `role` has any file, every role in `all` must have a file AND at least
 * one role in `any` must have a file. Empty lists are skipped.
 *
 * @generated from message creativefabrica.preset.v1.RequiresRule
 */
export type RequiresRule = Message<"creativefabrica.preset.v1.RequiresRule"> & {
  /**
   * @generated from field: string role = 1;
   */
  role: string;

  /**
   * @generated from field: repeated string all = 2;
   */
  all: string[];

  /**
   * @generated from field: repeated string any = 3;
   */
  any: string[];
};

/**
 * If `role` has any file, every role in `all` must have a file AND at least
 * one role in `any` must have a file. Empty lists are skipped.
 *
 * @generated from message creativefabrica.preset.v1.RequiresRule
 */
export type RequiresRuleJson = {
  /**
   * @generated from field: string role = 1;
   */
  role?: string;

  /**
   * @generated from field: repeated string all = 2;
   */
  all?: string[];

  /**
   * @generated from field: repeated string any = 3;
   */
  any?: string[];
};

/**
 * Describes the message creativefabrica.preset.v1.RequiresRule.
 * Use `create(RequiresRuleSchema)` to create a new message.
 */
export const RequiresRuleSchema: GenMessage<RequiresRule, {jsonType: RequiresRuleJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_types, 18);

/**
 * Sum of file counts across `roles` ≤ max.
 *
 * @generated from message creativefabrica.preset.v1.TotalMaxRule
 */
export type TotalMaxRule = Message<"creativefabrica.preset.v1.TotalMaxRule"> & {
  /**
   * @generated from field: repeated string roles = 1;
   */
  roles: string[];

  /**
   * @generated from field: int32 max = 2;
   */
  max: number;
};

/**
 * Sum of file counts across `roles` ≤ max.
 *
 * @generated from message creativefabrica.preset.v1.TotalMaxRule
 */
export type TotalMaxRuleJson = {
  /**
   * @generated from field: repeated string roles = 1;
   */
  roles?: string[];

  /**
   * @generated from field: int32 max = 2;
   */
  max?: number;
};

/**
 * Describes the message creativefabrica.preset.v1.TotalMaxRule.
 * Use `create(TotalMaxRuleSchema)` to create a new message.
 */
export const TotalMaxRuleSchema: GenMessage<TotalMaxRule, {jsonType: TotalMaxRuleJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_types, 19);

/**
 * Sum of per-file sizes (MB) across `roles` ≤ max_mb. Bounds a whole request
 * where maxFileSizeMb bounds one file, for providers that send every input
 * inline in a single body.
 *
 * @generated from message creativefabrica.preset.v1.TotalMaxMbRule
 */
export type TotalMaxMbRule = Message<"creativefabrica.preset.v1.TotalMaxMbRule"> & {
  /**
   * @generated from field: repeated string roles = 1;
   */
  roles: string[];

  /**
   * @generated from field: int32 max_mb = 2;
   */
  maxMb: number;
};

/**
 * Sum of per-file sizes (MB) across `roles` ≤ max_mb. Bounds a whole request
 * where maxFileSizeMb bounds one file, for providers that send every input
 * inline in a single body.
 *
 * @generated from message creativefabrica.preset.v1.TotalMaxMbRule
 */
export type TotalMaxMbRuleJson = {
  /**
   * @generated from field: repeated string roles = 1;
   */
  roles?: string[];

  /**
   * @generated from field: int32 max_mb = 2;
   */
  maxMb?: number;
};

/**
 * Describes the message creativefabrica.preset.v1.TotalMaxMbRule.
 * Use `create(TotalMaxMbRuleSchema)` to create a new message.
 */
export const TotalMaxMbRuleSchema: GenMessage<TotalMaxMbRule, {jsonType: TotalMaxMbRuleJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_types, 20);

/**
 * Caps the summed durations of files across `roles` PLUS the value of the
 * integer option `option`: "input seconds + output seconds <= max_seconds",
 * for models whose output includes their input (e.g. a video extension).
 *
 * @generated from message creativefabrica.preset.v1.MaxCombinedDurationWithOptionRule
 */
export type MaxCombinedDurationWithOptionRule = Message<"creativefabrica.preset.v1.MaxCombinedDurationWithOptionRule"> & {
  /**
   * @generated from field: repeated string roles = 1;
   */
  roles: string[];

  /**
   * @generated from field: string option = 2;
   */
  option: string;

  /**
   * @generated from field: int32 max_seconds = 3;
   */
  maxSeconds: number;
};

/**
 * Caps the summed durations of files across `roles` PLUS the value of the
 * integer option `option`: "input seconds + output seconds <= max_seconds",
 * for models whose output includes their input (e.g. a video extension).
 *
 * @generated from message creativefabrica.preset.v1.MaxCombinedDurationWithOptionRule
 */
export type MaxCombinedDurationWithOptionRuleJson = {
  /**
   * @generated from field: repeated string roles = 1;
   */
  roles?: string[];

  /**
   * @generated from field: string option = 2;
   */
  option?: string;

  /**
   * @generated from field: int32 max_seconds = 3;
   */
  maxSeconds?: number;
};

/**
 * Describes the message creativefabrica.preset.v1.MaxCombinedDurationWithOptionRule.
 * Use `create(MaxCombinedDurationWithOptionRuleSchema)` to create a new message.
 */
export const MaxCombinedDurationWithOptionRuleSchema: GenMessage<MaxCombinedDurationWithOptionRule, {jsonType: MaxCombinedDurationWithOptionRuleJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_types, 21);

/**
 * Sum of per-file durations (seconds) across `roles` ≤ max_seconds.
 * Only meaningful for roles whose files carry duration metadata (audio, video).
 *
 * @generated from message creativefabrica.preset.v1.TotalMaxDurationRule
 */
export type TotalMaxDurationRule = Message<"creativefabrica.preset.v1.TotalMaxDurationRule"> & {
  /**
   * @generated from field: repeated string roles = 1;
   */
  roles: string[];

  /**
   * @generated from field: int32 max_seconds = 2;
   */
  maxSeconds: number;
};

/**
 * Sum of per-file durations (seconds) across `roles` ≤ max_seconds.
 * Only meaningful for roles whose files carry duration metadata (audio, video).
 *
 * @generated from message creativefabrica.preset.v1.TotalMaxDurationRule
 */
export type TotalMaxDurationRuleJson = {
  /**
   * @generated from field: repeated string roles = 1;
   */
  roles?: string[];

  /**
   * @generated from field: int32 max_seconds = 2;
   */
  maxSeconds?: number;
};

/**
 * Describes the message creativefabrica.preset.v1.TotalMaxDurationRule.
 * Use `create(TotalMaxDurationRuleSchema)` to create a new message.
 */
export const TotalMaxDurationRuleSchema: GenMessage<TotalMaxDurationRule, {jsonType: TotalMaxDurationRuleJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_types, 22);

/**
 * When `when_role` has any file, `option` must not exceed `max_value`.
 *
 * @generated from message creativefabrica.preset.v1.ConditionalMaxOptionRule
 */
export type ConditionalMaxOptionRule = Message<"creativefabrica.preset.v1.ConditionalMaxOptionRule"> & {
  /**
   * @generated from field: string when_role = 1;
   */
  whenRole: string;

  /**
   * @generated from field: string option = 2;
   */
  option: string;

  /**
   * @generated from field: double max_value = 3;
   */
  maxValue: number;
};

/**
 * When `when_role` has any file, `option` must not exceed `max_value`.
 *
 * @generated from message creativefabrica.preset.v1.ConditionalMaxOptionRule
 */
export type ConditionalMaxOptionRuleJson = {
  /**
   * @generated from field: string when_role = 1;
   */
  whenRole?: string;

  /**
   * @generated from field: string option = 2;
   */
  option?: string;

  /**
   * @generated from field: double max_value = 3;
   */
  maxValue?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message creativefabrica.preset.v1.ConditionalMaxOptionRule.
 * Use `create(ConditionalMaxOptionRuleSchema)` to create a new message.
 */
export const ConditionalMaxOptionRuleSchema: GenMessage<ConditionalMaxOptionRule, {jsonType: ConditionalMaxOptionRuleJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_types, 23);

/**
 * When `when_role` has any file, `option` must be at least `min_value`
 * (e.g. Veo 3.1 Fast requires duration_seconds = 8 once a Studio Asset is
 * referenced). Mirror of ConditionalMaxOptionRule — the floor to its ceiling.
 *
 * `when_role` also accepts the well-known token "assetReference", meaning
 * "the request carries a Studio Asset mention". Studio Assets are not an
 * uploaded file role (they are declared by AssetReferenceCaps, not by
 * input_role_constraints), so they have no role name of their own; this token
 * is how an asset-conditional rule names them.
 *
 * @generated from message creativefabrica.preset.v1.ConditionalMinOptionRule
 */
export type ConditionalMinOptionRule = Message<"creativefabrica.preset.v1.ConditionalMinOptionRule"> & {
  /**
   * @generated from field: string when_role = 1;
   */
  whenRole: string;

  /**
   * @generated from field: string option = 2;
   */
  option: string;

  /**
   * @generated from field: double min_value = 3;
   */
  minValue: number;
};

/**
 * When `when_role` has any file, `option` must be at least `min_value`
 * (e.g. Veo 3.1 Fast requires duration_seconds = 8 once a Studio Asset is
 * referenced). Mirror of ConditionalMaxOptionRule — the floor to its ceiling.
 *
 * `when_role` also accepts the well-known token "assetReference", meaning
 * "the request carries a Studio Asset mention". Studio Assets are not an
 * uploaded file role (they are declared by AssetReferenceCaps, not by
 * input_role_constraints), so they have no role name of their own; this token
 * is how an asset-conditional rule names them.
 *
 * @generated from message creativefabrica.preset.v1.ConditionalMinOptionRule
 */
export type ConditionalMinOptionRuleJson = {
  /**
   * @generated from field: string when_role = 1;
   */
  whenRole?: string;

  /**
   * @generated from field: string option = 2;
   */
  option?: string;

  /**
   * @generated from field: double min_value = 3;
   */
  minValue?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message creativefabrica.preset.v1.ConditionalMinOptionRule.
 * Use `create(ConditionalMinOptionRuleSchema)` to create a new message.
 */
export const ConditionalMinOptionRuleSchema: GenMessage<ConditionalMinOptionRule, {jsonType: ConditionalMinOptionRuleJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_types, 24);

/**
 * When `when_role` has any file, the listed `options` do not apply and are
 * stripped from the request (e.g. aspect_ratio once a first frame is set).
 *
 * @generated from message creativefabrica.preset.v1.ConditionalUnavailableOptionsRule
 */
export type ConditionalUnavailableOptionsRule = Message<"creativefabrica.preset.v1.ConditionalUnavailableOptionsRule"> & {
  /**
   * @generated from field: string when_role = 1;
   */
  whenRole: string;

  /**
   * @generated from field: repeated string options = 2;
   */
  options: string[];
};

/**
 * When `when_role` has any file, the listed `options` do not apply and are
 * stripped from the request (e.g. aspect_ratio once a first frame is set).
 *
 * @generated from message creativefabrica.preset.v1.ConditionalUnavailableOptionsRule
 */
export type ConditionalUnavailableOptionsRuleJson = {
  /**
   * @generated from field: string when_role = 1;
   */
  whenRole?: string;

  /**
   * @generated from field: repeated string options = 2;
   */
  options?: string[];
};

/**
 * Describes the message creativefabrica.preset.v1.ConditionalUnavailableOptionsRule.
 * Use `create(ConditionalUnavailableOptionsRuleSchema)` to create a new message.
 */
export const ConditionalUnavailableOptionsRuleSchema: GenMessage<ConditionalUnavailableOptionsRule, {jsonType: ConditionalUnavailableOptionsRuleJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_types, 25);

/**
 * Preset is the top-level preset entity returned by admin endpoints.
 *
 * @generated from message creativefabrica.preset.v1.Preset
 */
export type Preset = Message<"creativefabrica.preset.v1.Preset"> & {
  /**
   * @generated from field: string preset_id = 1;
   */
  presetId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: creativefabrica.preset.v1.Modality modality = 3;
   */
  modality: Modality;

  /**
   * @generated from field: creativefabrica.preset.v1.OutputType output_type = 4;
   */
  outputType: OutputType;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: repeated creativefabrica.preset.v1.PresetVersion versions = 6;
   */
  versions: PresetVersion[];

  /**
   * A stub preset is a directory entry for a tool whose generations run in
   * another service: it anchors templates and names the tool, but its model
   * configs are not the generation contract. Template model validation does
   * not check a stub preset's model configs, and the modality service refuses
   * to generate from its templates itself.
   *
   * @generated from field: bool is_stub = 7;
   */
  isStub: boolean;

  /**
   * Free-form grouping labels, e.g. the tool that bundles several presets.
   * ListPresets filters on containment.
   *
   * @generated from field: repeated string tags = 8;
   */
  tags: string[];

  /**
   * Surfaces the preset is offered on. The API-key public API lists and runs
   * a preset only on the surfaces it declares; the Connect API serves every
   * preset regardless.
   *
   * @generated from field: repeated creativefabrica.common.v1.surface.v1.Surface surfaces = 10;
   */
  surfaces: Surface[];
};

/**
 * Preset is the top-level preset entity returned by admin endpoints.
 *
 * @generated from message creativefabrica.preset.v1.Preset
 */
export type PresetJson = {
  /**
   * @generated from field: string preset_id = 1;
   */
  presetId?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: creativefabrica.preset.v1.Modality modality = 3;
   */
  modality?: ModalityJson;

  /**
   * @generated from field: creativefabrica.preset.v1.OutputType output_type = 4;
   */
  outputType?: OutputTypeJson;

  /**
   * @generated from field: string description = 5;
   */
  description?: string;

  /**
   * @generated from field: repeated creativefabrica.preset.v1.PresetVersion versions = 6;
   */
  versions?: PresetVersionJson[];

  /**
   * A stub preset is a directory entry for a tool whose generations run in
   * another service: it anchors templates and names the tool, but its model
   * configs are not the generation contract. Template model validation does
   * not check a stub preset's model configs, and the modality service refuses
   * to generate from its templates itself.
   *
   * @generated from field: bool is_stub = 7;
   */
  isStub?: boolean;

  /**
   * Free-form grouping labels, e.g. the tool that bundles several presets.
   * ListPresets filters on containment.
   *
   * @generated from field: repeated string tags = 8;
   */
  tags?: string[];

  /**
   * Surfaces the preset is offered on. The API-key public API lists and runs
   * a preset only on the surfaces it declares; the Connect API serves every
   * preset regardless.
   *
   * @generated from field: repeated creativefabrica.common.v1.surface.v1.Surface surfaces = 10;
   */
  surfaces?: SurfaceJson[];
};

/**
 * Describes the message creativefabrica.preset.v1.Preset.
 * Use `create(PresetSchema)` to create a new message.
 */
export const PresetSchema: GenMessage<Preset, {jsonType: PresetJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_types, 26);

/**
 * PresetVersion describes a version of a preset with its full configuration.
 *
 * @generated from message creativefabrica.preset.v1.PresetVersion
 */
export type PresetVersion = Message<"creativefabrica.preset.v1.PresetVersion"> & {
  /**
   * @generated from field: int32 version = 1;
   */
  version: number;

  /**
   * @generated from field: creativefabrica.preset.v1.PresetVersionStatus status = 2;
   */
  status: PresetVersionStatus;

  /**
   * @generated from field: creativefabrica.preset.v1.SystemPrompt system_prompt = 3;
   */
  systemPrompt?: SystemPrompt | undefined;

  /**
   * @generated from field: repeated creativefabrica.preset.v1.PresetModelConfig model_configs = 4;
   */
  modelConfigs: PresetModelConfig[];
};

/**
 * PresetVersion describes a version of a preset with its full configuration.
 *
 * @generated from message creativefabrica.preset.v1.PresetVersion
 */
export type PresetVersionJson = {
  /**
   * @generated from field: int32 version = 1;
   */
  version?: number;

  /**
   * @generated from field: creativefabrica.preset.v1.PresetVersionStatus status = 2;
   */
  status?: PresetVersionStatusJson;

  /**
   * @generated from field: creativefabrica.preset.v1.SystemPrompt system_prompt = 3;
   */
  systemPrompt?: SystemPromptJson;

  /**
   * @generated from field: repeated creativefabrica.preset.v1.PresetModelConfig model_configs = 4;
   */
  modelConfigs?: PresetModelConfigJson[];
};

/**
 * Describes the message creativefabrica.preset.v1.PresetVersion.
 * Use `create(PresetVersionSchema)` to create a new message.
 */
export const PresetVersionSchema: GenMessage<PresetVersion, {jsonType: PresetVersionJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_types, 27);

/**
 * PresetModelConfig describes a model configuration within a preset version.
 *
 * @generated from message creativefabrica.preset.v1.PresetModelConfig
 */
export type PresetModelConfig = Message<"creativefabrica.preset.v1.PresetModelConfig"> & {
  /**
   * @generated from field: string model = 1;
   */
  model: string;

  /**
   * @generated from field: string provider = 2;
   */
  provider: string;

  /**
   * @generated from field: bool is_default = 3;
   */
  isDefault: boolean;

  /**
   * @generated from field: creativefabrica.preset.v1.ModelConfig model_config = 4;
   */
  modelConfig?: ModelConfig | undefined;

  /**
   * @generated from field: creativefabrica.preset.v1.CoinConfig coin_config = 5;
   */
  coinConfig?: CoinConfig | undefined;
};

/**
 * PresetModelConfig describes a model configuration within a preset version.
 *
 * @generated from message creativefabrica.preset.v1.PresetModelConfig
 */
export type PresetModelConfigJson = {
  /**
   * @generated from field: string model = 1;
   */
  model?: string;

  /**
   * @generated from field: string provider = 2;
   */
  provider?: string;

  /**
   * @generated from field: bool is_default = 3;
   */
  isDefault?: boolean;

  /**
   * @generated from field: creativefabrica.preset.v1.ModelConfig model_config = 4;
   */
  modelConfig?: ModelConfigJson;

  /**
   * @generated from field: creativefabrica.preset.v1.CoinConfig coin_config = 5;
   */
  coinConfig?: CoinConfigJson;
};

/**
 * Describes the message creativefabrica.preset.v1.PresetModelConfig.
 * Use `create(PresetModelConfigSchema)` to create a new message.
 */
export const PresetModelConfigSchema: GenMessage<PresetModelConfig, {jsonType: PresetModelConfigJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_preset_v1_types, 28);

/**
 * Modality describes the input→output type pair. Set on the preset, not by the client.
 *
 * @generated from enum creativefabrica.preset.v1.Modality
 */
export enum Modality {
  /**
   * @generated from enum value: MODALITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MODALITY_TEXT_TO_IMAGE = 1;
   */
  TEXT_TO_IMAGE = 1,

  /**
   * @generated from enum value: MODALITY_IMAGE_TO_IMAGE = 2;
   */
  IMAGE_TO_IMAGE = 2,

  /**
   * @generated from enum value: MODALITY_TEXT_TO_AUDIO = 3;
   */
  TEXT_TO_AUDIO = 3,

  /**
   * @generated from enum value: MODALITY_TEXT_TO_VIDEO = 4;
   */
  TEXT_TO_VIDEO = 4,

  /**
   * @generated from enum value: MODALITY_TEXT_TO_TEXT = 5;
   */
  TEXT_TO_TEXT = 5,

  /**
   * @generated from enum value: MODALITY_IMAGE_TO_TEXT = 6;
   */
  IMAGE_TO_TEXT = 6,

  /**
   * @generated from enum value: MODALITY_IMAGE_TO_3D = 7;
   */
  IMAGE_TO_3D = 7,

  /**
   * heterogeneous file inputs (frames + reference image/audio/video) → video
   *
   * @generated from enum value: MODALITY_MEDIA_TO_VIDEO = 8;
   */
  MEDIA_TO_VIDEO = 8,

  /**
   * role-keyed file inputs (e.g. sourceVideo) → structured text/JSON output
   *
   * @generated from enum value: MODALITY_MEDIA_TO_TEXT = 9;
   */
  MEDIA_TO_TEXT = 9,

  /**
   * text prompt → 3D model output
   *
   * @generated from enum value: MODALITY_TEXT_TO_3D = 10;
   */
  TEXT_TO_3D = 10,

  /**
   * role-keyed file inputs (reference audio/image) → audio output
   *
   * @generated from enum value: MODALITY_MEDIA_TO_AUDIO = 11;
   */
  MEDIA_TO_AUDIO = 11,

  /**
   * role-keyed file inputs (e.g. sourceVideo) → one or more image outputs
   *
   * @generated from enum value: MODALITY_MEDIA_TO_IMAGE = 12;
   */
  MEDIA_TO_IMAGE = 12,
}

/**
 * Modality describes the input→output type pair. Set on the preset, not by the client.
 *
 * @generated from enum creativefabrica.preset.v1.Modality
 */
export type ModalityJson = "MODALITY_UNSPECIFIED" | "MODALITY_TEXT_TO_IMAGE" | "MODALITY_IMAGE_TO_IMAGE" | "MODALITY_TEXT_TO_AUDIO" | "MODALITY_TEXT_TO_VIDEO" | "MODALITY_TEXT_TO_TEXT" | "MODALITY_IMAGE_TO_TEXT" | "MODALITY_IMAGE_TO_3D" | "MODALITY_MEDIA_TO_VIDEO" | "MODALITY_MEDIA_TO_TEXT" | "MODALITY_TEXT_TO_3D" | "MODALITY_MEDIA_TO_AUDIO" | "MODALITY_MEDIA_TO_IMAGE";

/**
 * Describes the enum creativefabrica.preset.v1.Modality.
 */
export const ModalitySchema: GenEnum<Modality, ModalityJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_preset_v1_types, 0);

/**
 * OutputType describes the kind of media a generation produces.
 *
 * @generated from enum creativefabrica.preset.v1.OutputType
 */
export enum OutputType {
  /**
   * @generated from enum value: OUTPUT_TYPE_UNSPECIFIED = 0;
   */
  OUTPUT_TYPE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: OUTPUT_TYPE_IMAGE = 1;
   */
  OUTPUT_TYPE_IMAGE = 1,

  /**
   * @generated from enum value: OUTPUT_TYPE_AUDIO = 2;
   */
  OUTPUT_TYPE_AUDIO = 2,

  /**
   * @generated from enum value: OUTPUT_TYPE_VIDEO = 3;
   */
  OUTPUT_TYPE_VIDEO = 3,

  /**
   * @generated from enum value: OUTPUT_TYPE_3D_MODEL = 4;
   */
  OUTPUT_TYPE_3D_MODEL = 4,

  /**
   * @generated from enum value: OUTPUT_TYPE_TEXT = 5;
   */
  OUTPUT_TYPE_TEXT = 5,

  /**
   * one base image plus positioned alpha layers
   *
   * @generated from enum value: OUTPUT_TYPE_LAYERED_IMAGE = 6;
   */
  OUTPUT_TYPE_LAYERED_IMAGE = 6,
}

/**
 * OutputType describes the kind of media a generation produces.
 *
 * @generated from enum creativefabrica.preset.v1.OutputType
 */
export type OutputTypeJson = "OUTPUT_TYPE_UNSPECIFIED" | "OUTPUT_TYPE_IMAGE" | "OUTPUT_TYPE_AUDIO" | "OUTPUT_TYPE_VIDEO" | "OUTPUT_TYPE_3D_MODEL" | "OUTPUT_TYPE_TEXT" | "OUTPUT_TYPE_LAYERED_IMAGE";

/**
 * Describes the enum creativefabrica.preset.v1.OutputType.
 */
export const OutputTypeSchema: GenEnum<OutputType, OutputTypeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_preset_v1_types, 1);

/**
 * PresetVersionStatus tracks the lifecycle of a preset version.
 *
 * @generated from enum creativefabrica.preset.v1.PresetVersionStatus
 */
export enum PresetVersionStatus {
  /**
   * @generated from enum value: PRESET_VERSION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PRESET_VERSION_STATUS_DRAFT = 1;
   */
  DRAFT = 1,

  /**
   * @generated from enum value: PRESET_VERSION_STATUS_ACTIVE = 2;
   */
  ACTIVE = 2,

  /**
   * @generated from enum value: PRESET_VERSION_STATUS_ARCHIVED = 3;
   */
  ARCHIVED = 3,

  /**
   * @generated from enum value: PRESET_VERSION_STATUS_INACTIVE = 4;
   */
  INACTIVE = 4,
}

/**
 * PresetVersionStatus tracks the lifecycle of a preset version.
 *
 * @generated from enum creativefabrica.preset.v1.PresetVersionStatus
 */
export type PresetVersionStatusJson = "PRESET_VERSION_STATUS_UNSPECIFIED" | "PRESET_VERSION_STATUS_DRAFT" | "PRESET_VERSION_STATUS_ACTIVE" | "PRESET_VERSION_STATUS_ARCHIVED" | "PRESET_VERSION_STATUS_INACTIVE";

/**
 * Describes the enum creativefabrica.preset.v1.PresetVersionStatus.
 */
export const PresetVersionStatusSchema: GenEnum<PresetVersionStatus, PresetVersionStatusJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_preset_v1_types, 2);

/**
 * CoinPricingType distinguishes how the coin cost is determined.
 *
 * @generated from enum creativefabrica.preset.v1.CoinPricingType
 */
export enum CoinPricingType {
  /**
   * @generated from enum value: COIN_PRICING_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * fixed cost per generation
   *
   * @generated from enum value: COIN_PRICING_TYPE_STATIC = 1;
   */
  STATIC = 1,

  /**
   * cost computed by the backend based on input params
   *
   * @generated from enum value: COIN_PRICING_TYPE_DYNAMIC = 2;
   */
  DYNAMIC = 2,
}

/**
 * CoinPricingType distinguishes how the coin cost is determined.
 *
 * @generated from enum creativefabrica.preset.v1.CoinPricingType
 */
export type CoinPricingTypeJson = "COIN_PRICING_TYPE_UNSPECIFIED" | "COIN_PRICING_TYPE_STATIC" | "COIN_PRICING_TYPE_DYNAMIC";

/**
 * Describes the enum creativefabrica.preset.v1.CoinPricingType.
 */
export const CoinPricingTypeSchema: GenEnum<CoinPricingType, CoinPricingTypeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_preset_v1_types, 3);

/**
 * SystemPromptType distinguishes how the prompt text is used.
 *
 * @generated from enum creativefabrica.preset.v1.SystemPromptType
 */
export enum SystemPromptType {
  /**
   * @generated from enum value: SYSTEM_PROMPT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * prompt text is used as-is
   *
   * @generated from enum value: SYSTEM_PROMPT_TYPE_STATIC = 1;
   */
  STATIC = 1,

  /**
   * prompt text contains {{variable}} placeholders
   *
   * @generated from enum value: SYSTEM_PROMPT_TYPE_TEMPLATE = 2;
   */
  TEMPLATE = 2,

  /**
   * prompt text uses Go stdlib text/template syntax
   *
   * @generated from enum value: SYSTEM_PROMPT_TYPE_GO_TEXT_TEMPLATE = 3;
   */
  GO_TEXT_TEMPLATE = 3,
}

/**
 * SystemPromptType distinguishes how the prompt text is used.
 *
 * @generated from enum creativefabrica.preset.v1.SystemPromptType
 */
export type SystemPromptTypeJson = "SYSTEM_PROMPT_TYPE_UNSPECIFIED" | "SYSTEM_PROMPT_TYPE_STATIC" | "SYSTEM_PROMPT_TYPE_TEMPLATE" | "SYSTEM_PROMPT_TYPE_GO_TEXT_TEMPLATE";

/**
 * Describes the enum creativefabrica.preset.v1.SystemPromptType.
 */
export const SystemPromptTypeSchema: GenEnum<SystemPromptType, SystemPromptTypeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_preset_v1_types, 4);

